/**
 * Pattern Metadata
 *
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by: npm run build:patterns
 * Last generated: 2026-01-22T23:20:48.647Z
 *
 * This file contains lightweight metadata for all 1163 bingo patterns.
 * Pattern grid data is NOT included here - it's lazy-loaded on demand from
 * the individual pattern files in src/helpers/patterns/
 *
 * This reduces the main bundle size by ~750KB.
 */

export const patternMetadata = [
  {
    "value": "Custom",
    "label": "Custom",
    "otherNames": [],
    "source": null,
    "credit": null
  },
  {
    "value": "Postage Stamp & Zip Code",
    "label": "Postage Stamp & Zip Code",
    "otherNames": [],
    "source": "new",
    "credit": "Lorie Bodi",
    "isCombo": false
  },
  {
    "value": "4 Lines Anyway Not Using Free",
    "label": "4 Lines Anyway Not Using Free",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Double C (Alternate)",
    "label": "Double C (Alternate)",
    "otherNames": [],
    "source": "new",
    "credit": "Claire Bickel",
    "isCombo": false
  },
  {
    "value": "Must Spell Bingo",
    "label": "Must Spell Bingo",
    "otherNames": [],
    "source": "new",
    "credit": "Dan S",
    "isCombo": false
  },
  {
    "value": "Snowflake (Alternate 3)",
    "label": "Snowflake 3 (Alternate 3)",
    "otherNames": [],
    "source": "new",
    "credit": "Shelia",
    "isCombo": false
  },
  {
    "value": "Double 4 Corners",
    "label": "Double 4 Corners",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "X Or Plus",
    "label": "X Or Plus",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter L (Inverted)",
    "label": "Letter L (Inverted)",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Pie",
    "label": "Pie",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Large Triangle",
    "label": "Large Triangle",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Snowflake (Alternate 4)",
    "label": "Snowflake (Alternate 4)",
    "otherNames": [],
    "source": "new",
    "credit": "Bettyann",
    "isCombo": false
  },
  {
    "value": "Number 26",
    "label": "Number 26",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 20",
    "label": "Number 20",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "3 Lines",
    "label": "3 Lines",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Double Chevron (Alternate)",
    "label": "Double Chevron (Alternate)",
    "otherNames": [],
    "source": "new",
    "credit": "Millzzy",
    "isCombo": false
  },
  {
    "value": "Number 9 (Alternate 3)",
    "label": "Number 9 (Alternate 3)",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "26",
    "label": "26",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crazy Bow Tie",
    "label": "Crazy Bow Tie",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "4 Corners Into Triple Dot",
    "label": "4 Corners Into Triple Dot",
    "otherNames": [],
    "source": "new",
    "credit": "Louise Durgin",
    "isCombo": true
  },
  {
    "value": "Any Line Of The Layer Cake Into The Layer Cake",
    "label": "Any Line Of The Layer Cake Into The Layer Cake",
    "otherNames": [],
    "source": "new",
    "credit": "Louise Durgin",
    "isCombo": true
  },
  {
    "value": "Any Outside Line Into Crazy U",
    "label": "Any Outside Line Into Crazy U",
    "otherNames": [],
    "source": "new",
    "credit": "Louise Durgin",
    "isCombo": true
  },
  {
    "value": "6 Pack Or A Stamp Into 6 Pack And A Stamp",
    "label": "6 Pack Or A Stamp Into 6 Pack And A Stamp",
    "otherNames": [],
    "source": "new",
    "credit": "Louise Durgin",
    "isCombo": true
  },
  {
    "value": "3 On Top And Bottom Into Top And Bottom",
    "label": "3 On Top And Bottom Into Top And Bottom",
    "otherNames": [],
    "source": "new",
    "credit": "Louise Durgin",
    "isCombo": true
  },
  {
    "value": "Crazy Kite Into Triple Postage",
    "label": "Crazy Kite Into Triple Postage",
    "otherNames": [],
    "source": "new",
    "credit": "Louise Durgin",
    "isCombo": true
  },
  {
    "value": "Any 9 Into Triple Bingo",
    "label": "Any 9 Into Triple Bingo",
    "otherNames": [],
    "source": "new",
    "credit": "Louise Durgin",
    "isCombo": true
  },
  {
    "value": "Inside Corners Into Letter K",
    "label": "Inside Corners Into Letter K",
    "otherNames": [],
    "source": "new",
    "credit": "Louise Durgin",
    "isCombo": true
  },
  {
    "value": "4 Corners Into Triple Trio",
    "label": "4 Corners Into Triple Trio",
    "otherNames": [],
    "source": "new",
    "credit": "Louise Durgin",
    "isCombo": true
  },
  {
    "value": "Garbage Into Inside Into Letter H Into Coverall",
    "label": "Garbage Into Inside Into Letter H Into Coverall",
    "otherNames": [],
    "source": "new",
    "credit": "Louise Durgin",
    "isCombo": true
  },
  {
    "value": "Inside Into Outside Into Coverall",
    "label": "Inside Into Outside Into Coverall",
    "otherNames": [],
    "source": "new",
    "credit": "Louise Durgin",
    "isCombo": true
  },
  {
    "value": "Single Bingo Into Double Postage Into Triple Bingo (Hardway) Into Coverall",
    "label": "Single Bingo Into Double Postage Into Triple Bingo (Hardway) Into Coverall",
    "otherNames": [],
    "source": "new",
    "credit": "Louise Durgin",
    "isCombo": true
  },
  {
    "value": "Dog Bone Into Letter H",
    "label": "Dog Bone Into Letter H",
    "otherNames": [],
    "source": "new",
    "credit": "Louise Durgin",
    "isCombo": true
  },
  {
    "value": "Double Postage A Into Large Kite",
    "label": "Double Postage A Into Large Kite",
    "otherNames": [],
    "source": "new",
    "credit": "Louise Durgin",
    "isCombo": true
  },
  {
    "value": "Bingo Hardway Into Letter X Into Top Hat Into Coverall",
    "label": "Bingo Hardway Into Letter X Into Top Hat Into Coverall",
    "otherNames": [],
    "source": "new",
    "credit": "Louise Durgin",
    "isCombo": true
  },
  {
    "value": "Single Into Letter X Into Left Side Right Side Into Coverall",
    "label": "Single Into Letter X Into Left Side Right Side Into Coverall",
    "otherNames": [],
    "source": "new",
    "credit": "Louise Durgin",
    "isCombo": true
  },
  {
    "value": "Crazy Sandwich",
    "label": "Crazy Sandwich",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Fallen Tree",
    "label": "Fallen Tree",
    "otherNames": [],
    "source": "new",
    "credit": "Liz Mason",
    "isCombo": false
  },
  {
    "value": "Steamboat",
    "label": "Steamboat",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Happy Face (Alternate 2)",
    "label": "Happy Face (Alternate 2)",
    "otherNames": [],
    "source": "new",
    "credit": "VibRibbon",
    "isCombo": false
  },
  {
    "value": "Letter L (Alternate 4)",
    "label": "Letter L (Alternate 4)",
    "otherNames": [],
    "source": "new",
    "credit": "Glencoe Lions",
    "isCombo": false
  },
  {
    "value": "Letter G (Alternate 4)",
    "label": "Letter G (Alternate 4)",
    "otherNames": [],
    "source": "new",
    "credit": "Glencoe Lions",
    "isCombo": false
  },
  {
    "value": "Half Staff Flag",
    "label": "Half Staff Flag",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Little Brown Jug (Alternative Sides)",
    "label": "Little Brown Jug (Alternative Sides)",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 70",
    "label": "Number 70",
    "otherNames": [
      "Seventy"
    ],
    "source": "new",
    "credit": "Llewellyn Weaver",
    "isCombo": false
  },
  {
    "value": "Boot (Alternate)",
    "label": "Boot (Alternate)",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Lips",
    "label": "Lips",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crazy Z",
    "label": "Crazy Z",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Rockstar",
    "label": "Rockstar",
    "otherNames": [],
    "source": "new",
    "credit": "JayDubz",
    "isCombo": false
  },
  {
    "value": "6 Ways To Bingo Minis",
    "label": "6 Ways To Bingo Minis",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Number 30",
    "label": "Number 30",
    "otherNames": [],
    "source": "new",
    "credit": "Claire Bickel",
    "isCombo": false
  },
  {
    "value": "30 Backwards",
    "label": "30 Backwards",
    "otherNames": [],
    "source": "new",
    "credit": "Claire Bickel",
    "isCombo": false
  },
  {
    "value": "The Wine Glass",
    "label": "The Wine Glass",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Left Shot",
    "label": "Left Shot",
    "otherNames": [],
    "source": "new",
    "credit": "Kathy Helmlu",
    "isCombo": false
  },
  {
    "value": "Right Shot",
    "label": "Right Shot",
    "otherNames": [],
    "source": "new",
    "credit": "Kathy Helmly",
    "isCombo": false
  },
  {
    "value": "Double Corners",
    "label": "Double Corners",
    "otherNames": [],
    "source": "new",
    "credit": "Kathy Helmly",
    "isCombo": false
  },
  {
    "value": "Crazy Letter C",
    "label": "Crazy Letter C",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Full House",
    "label": "Full House",
    "otherNames": [],
    "source": "new",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "1 Bar Into Jail Or Prison Bars",
    "label": "1 Bar Into Jail Or Prison Bars",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "1-Go Go 1 Through 4",
    "label": "1-Go Go 1 Through 4",
    "otherNames": [],
    "source": "combos",
    "credit": "Sharon Rose",
    "isCombo": true
  },
  {
    "value": "15 Block Anywhere",
    "label": "15 Block Anywhere",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "2 Right Feet",
    "label": "2 Right Feet",
    "otherNames": [],
    "source": "combos",
    "credit": "Claire Bickel",
    "isCombo": true
  },
  {
    "value": "3 Bingos Corners Good",
    "label": "3 Bingos Corners Good",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "3 Legged X",
    "label": "3 Legged X",
    "otherNames": [],
    "source": "combos",
    "credit": "Manny Garcia",
    "isCombo": true
  },
  {
    "value": "3 Star",
    "label": "3 Star",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "3 Straight Lines",
    "label": "3 Straight Lines",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "4 Corners Into Butterfly",
    "label": "4 Corners Into Butterfly",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "4 Corners With Mini Backout",
    "label": "4 Corners With Mini Backout",
    "otherNames": [],
    "source": "combos",
    "credit": "Claire Bickel",
    "isCombo": false
  },
  {
    "value": "4 Dots Except Free Space",
    "label": "4 Dots Except Free Space",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "7 Into Letter Z",
    "label": "7 Into Letter Z",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "16 Lines Minimum Of 4",
    "label": "16 Lines Minimum Of 4",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Any 2 Lines/Any Kite/Bacon & Eggs",
    "label": "Any 2 Lines/Any Kite/Bacon & Eggs",
    "otherNames": [],
    "source": "combos",
    "credit": "Sharon Rose",
    "isCombo": true
  },
  {
    "value": "Baseball (Combo)",
    "label": "Baseball (Combo)",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "BIN, GO & Coverall",
    "label": "BIN, GO & Coverall",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Bingo Any Way",
    "label": "Bingo Any Way",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Block Of Nine And 4 Corners",
    "label": "Block Of Nine And 4 Corners",
    "otherNames": [],
    "source": "combos",
    "credit": "LaVeda",
    "isCombo": true
  },
  {
    "value": "Bottom Row Into Top Hat",
    "label": "Bottom Row Into Top Hat",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Cab",
    "label": "Cab",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Crazy Bingo",
    "label": "Crazy Bingo",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Cross (Combo)",
    "label": "Cross (Combo)",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Diagonal Into Z",
    "label": "Diagonal Into Z",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Diamonds",
    "label": "Diamonds",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Diamonds (Combo)",
    "label": "Diamonds (Combo)",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Even Couple (6&8)",
    "label": "Even Couple (6&8)",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Express Bingo",
    "label": "Express Bingo",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Fekr",
    "label": "Fekr",
    "otherNames": [],
    "source": "combos",
    "credit": "Million",
    "isCombo": true
  },
  {
    "value": "Four For Four",
    "label": "Four For Four",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Frames & Coverall",
    "label": "Frames & Coverall",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Garbage 4 Corners, Single, Corner Stamp",
    "label": "Garbage 4 Corners, Single, Corner Stamp",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Half X Into Letter X",
    "label": "Half X Into Letter X",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Hearts & Blackout",
    "label": "Hearts & Blackout",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Inside Frame, Outside Frame",
    "label": "Inside Frame, Outside Frame",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Large Picture Frame And Blackout",
    "label": "Large Picture Frame And Blackout",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Layer Cake, Filling & Blackout",
    "label": "Layer Cake, Filling & Blackout",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Left & Right Feet",
    "label": "Left & Right Feet",
    "otherNames": [],
    "source": "combos",
    "credit": "Claire Bickel",
    "isCombo": true
  },
  {
    "value": "Line, 4 Corners & Coverall",
    "label": "Line, 4 Corners & Coverall",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Odd Couple (6&9)",
    "label": "Odd Couple (6&9)",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "One Row Into Full Flag",
    "label": "One Row Into Full Flag",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "One Short Of A Dozen",
    "label": "One Short Of A Dozen",
    "otherNames": [],
    "source": "combos",
    "credit": "Manny Garcia",
    "isCombo": true
  },
  {
    "value": "Plus Or X Into Snowflake",
    "label": "Plus Or X Into Snowflake",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Pyramid (Combo)",
    "label": "Pyramid (Combo)",
    "otherNames": [],
    "source": "combos",
    "credit": "larry legarde",
    "isCombo": true
  },
  {
    "value": "Reindeer to Full Card",
    "label": "Reindeer to Full Card",
    "otherNames": [],
    "source": "combos",
    "credit": "BettaWithBingo",
    "isCombo": true
  },
  {
    "value": "Six Pack (No Ns)",
    "label": "Six Pack (No Ns)",
    "otherNames": [],
    "source": "combos",
    "credit": "Matty",
    "isCombo": true
  },
  {
    "value": "Small Letter 'X' Into A Large Letter 'X'",
    "label": "Small Letter 'X' Into A Large Letter 'X'",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Small Triangle, Big Triangle & Blackout",
    "label": "Small Triangle, Big Triangle & Blackout",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Stamps",
    "label": "Stamps",
    "otherNames": [
      "Postage Stamps",
      "Stamps Combo"
    ],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Target",
    "label": "Target",
    "otherNames": [],
    "source": "combos",
    "credit": "LARRY LEGARDE",
    "isCombo": true
  },
  {
    "value": "Top, Bottom & Blackout",
    "label": "Top, Bottom & Blackout",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Top Line into A Z",
    "label": "Top Line into A Z",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Top Or Bottom Row Into Letter C",
    "label": "Top Or Bottom Row Into Letter C",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Top Or Bottom Row Into Letter E",
    "label": "Top Or Bottom Row Into Letter E",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "X Into Full House",
    "label": "X Into Full House",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "X Into Hourglass",
    "label": "X Into Hourglass",
    "otherNames": [],
    "source": "combos",
    "credit": null,
    "isCombo": true
  },
  {
    "value": "Zig Zag Into Letter H",
    "label": "Zig Zag Into Letter H",
    "otherNames": [],
    "source": "combos",
    "credit": "Louise Durgin",
    "isCombo": true
  },
  {
    "value": "1 2 3 4 5",
    "label": "1 2 3 4 5",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "1 2 3 4 5 (As Shown)",
    "label": "1 2 3 4 5 (As Shown)",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "1 Corner Postage Stamp",
    "label": "1 Corner Postage Stamp",
    "otherNames": [
      "One Stamp",
      "One Corner Postage Stamp",
      "One Postage Stamp",
      "1 Stamp",
      "1 Postage Stamp"
    ],
    "source": "numerical",
    "credit": "Bret Rice",
    "isCombo": false
  },
  {
    "value": "1 Hardway & 1 Easyway Bingo",
    "label": "1 Hardway & 1 Easyway Bingo",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "1 Line & Block Of Four",
    "label": "1 Line & Block Of Four",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "12 Days Of Christmas",
    "label": "12 Days Of Christmas",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "12 Dots",
    "label": "12 Dots",
    "otherNames": [
      "12 Dotes"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "12 Dots (Reversed)",
    "label": "12 Dots (Reversed)",
    "otherNames": [
      "12 Reverse"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "1K",
    "label": "1K",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "10/2/4",
    "label": "10/2/4",
    "otherNames": [
      "Ten Two Four"
    ],
    "source": "numerical",
    "credit": "Norma Davis",
    "isCombo": false
  },
  {
    "value": "10 Block Anywhere",
    "label": "10 Block Anywhere",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "20 Ways",
    "label": "20 Ways",
    "otherNames": [
      "Twenty Ways"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "22",
    "label": "22",
    "otherNames": [],
    "source": "numerical",
    "credit": "Sangeeta Khemka ",
    "isCombo": false
  },
  {
    "value": "2 Blocks Of 4",
    "label": "2 Blocks Of 4",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "2 Bottom Lines",
    "label": "2 Bottom Lines",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "2 Corner Postage Stamps",
    "label": "2 Corner Postage Stamps",
    "otherNames": [],
    "source": "numerical",
    "credit": "JoAnn Elizabeth Reinhardt",
    "isCombo": false
  },
  {
    "value": "2 Corners 2 Stamps",
    "label": "2 Corners 2 Stamps",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "2 Crazy Small Stamps",
    "label": "2 Crazy Small Stamps",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "2 Hardway",
    "label": "2 Hardway",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "2 Kites",
    "label": "2 Kites",
    "otherNames": [],
    "source": "numerical",
    "credit": "Claire Bickel",
    "isCombo": false
  },
  {
    "value": "2 Lines - One Vertical, One Horizontal",
    "label": "2 Lines - One Vertical, One Horizontal",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "2 Lines Or 1 Line And 4 Corners",
    "label": "2 Lines Or 1 Line And 4 Corners",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "2 Stamps Anywhere — No Free Space",
    "label": "2 Stamps Anywhere — No Free Space",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "2 Straight Lines",
    "label": "2 Straight Lines",
    "otherNames": [],
    "source": "numerical",
    "credit": "Convivial Kendrea",
    "isCombo": false
  },
  {
    "value": "23 And Free",
    "label": "23 And Free",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "2K",
    "label": "2K",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "2 Lines Through Free Space",
    "label": "2 Lines Through Free Space",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "2x2x2",
    "label": "2x2x2",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "3 Corner Postage Stamps",
    "label": "3 Corner Postage Stamps",
    "otherNames": [
      "Three Stamps, Three Postage Stamps",
      "Three Corner Postage Stamps",
      "3 Stamps",
      "3 Postage Stamps"
    ],
    "source": "numerical",
    "credit": "Bret Rice",
    "isCombo": false
  },
  {
    "value": "3 Diagonal Lines",
    "label": "3 Diagonal Lines",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "3 Diagonal Lines (Alternate)",
    "label": "3 Diagonal Lines (Alternate)",
    "otherNames": [],
    "source": "numerical",
    "credit": "DJ Chris",
    "isCombo": false
  },
  {
    "value": "3 Dot B And O",
    "label": "3 Dot B And O",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "3 Dots Diagonal Anywhere",
    "label": "3 Dots Diagonal Anywhere",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "3 In The Corner",
    "label": "3 In The Corner",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "3 Leaf Clover",
    "label": "3 Leaf Clover",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "3 Lines- Diagonal, Horizontal, Vertical",
    "label": "3 Lines- Diagonal, Horizontal, Vertical",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "3 Number Diagonal",
    "label": "3 Number Diagonal",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "3 On Top 3 On Bottom",
    "label": "3 On Top 3 On Bottom",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "3 On The Top And Bottom",
    "label": "3 On The Top And Bottom",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "3 Rows",
    "label": "3 Rows",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "3 Stamps, 3 Lines Anywhere",
    "label": "3 Stamps, 3 Lines Anywhere",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "3 Straight And Corner Stamps Anywhere",
    "label": "3 Straight And Corner Stamps Anywhere",
    "otherNames": [],
    "source": "numerical",
    "credit": "Sedy",
    "isCombo": false
  },
  {
    "value": "30",
    "label": "30",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "34",
    "label": "34",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "3x3x3",
    "label": "3x3x3",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "4",
    "label": "4",
    "otherNames": [],
    "source": "numerical",
    "credit": "Monique Haeyn",
    "isCombo": false
  },
  {
    "value": "4 Card Hardway Triple Dot",
    "label": "4 Card Hardway Triple Dot",
    "otherNames": [
      "4 Card Hw Triple Dot"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "4 Card Hardway Triple Dot Diagonals Ok",
    "label": "4 Card Hardway Triple Dot Diagonals Ok",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "4 Corners And A Line",
    "label": "4 Corners And A Line",
    "otherNames": [
      "4 Courners And A Line",
      "1 Ligne And 4 Corners",
      "Single Bingo Anywhere Plus 4 Corners"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "4 Corner",
    "label": "4 Corner",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "4 Corners",
    "label": "4 Corners",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "4 Corner Postage Stamps",
    "label": "4 Corner Postage Stamps",
    "otherNames": [
      "Four Stamps",
      "4 Stamps",
      "4 Postage Stamps",
      "Four Postage Stamps"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "4 Corners + Free Space",
    "label": "4 Corners + Free Space",
    "otherNames": [],
    "source": "numerical",
    "credit": "Princess B",
    "isCombo": false
  },
  {
    "value": "4 Diagonal",
    "label": "4 Diagonal",
    "otherNames": [
      "4 Dots Diagonal"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "4 Diagonal (Anywhere)",
    "label": "4 Diagonal (Anywhere)",
    "otherNames": [
      "4 Dots Diagonal Anywhere"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "4 x 4 As Shown",
    "label": "4 x 4 As Shown",
    "otherNames": [
      "Four by Four As Shown"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "4 x 4 Anywhere",
    "label": "4 x 4 Anywhere",
    "otherNames": [
      "Four by Four Anywhere"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "4x3x4",
    "label": "4x3x4",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "5-4-3-2-1",
    "label": "5-4-3-2-1",
    "otherNames": [],
    "source": "numerical",
    "credit": "ChrisB",
    "isCombo": false
  },
  {
    "value": "5 And 3 Anywhere",
    "label": "5 And 3 Anywhere",
    "otherNames": [],
    "source": "numerical",
    "credit": "Louise Durgin",
    "isCombo": false
  },
  {
    "value": "5 Around The Corner",
    "label": "5 Around The Corner",
    "otherNames": [
      "Five Around The Corner"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "50",
    "label": "50",
    "otherNames": [
      "Fifty"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "5k",
    "label": "5k",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "6 7",
    "label": "6 7",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "67 Pattern",
    "label": "67 Pattern",
    "otherNames": [],
    "source": "numerical",
    "credit": "67 King",
    "isCombo": false
  },
  {
    "value": "6 Around The Corner",
    "label": "6 Around The Corner",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "6 Circles",
    "label": "6 Circles",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "6 Pack, 9 Pack",
    "label": "6 Pack, 9 Pack",
    "otherNames": [
      "Six Pack, Nine Pack"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "6 Pack & Bingo No Overlap",
    "label": "6 Pack & Bingo No Overlap",
    "otherNames": [
      "Six Pack & Bingo No Overlap"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "6 Pack As Shown",
    "label": "6 Pack As Shown",
    "otherNames": [
      "Six Pack As Shown"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "6 Pack",
    "label": "6 Pack",
    "otherNames": [
      "Six Pack"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "6 Pack & A Line",
    "label": "6 Pack & A Line",
    "otherNames": [
      "Six Pack & A Line"
    ],
    "source": "numerical",
    "credit": "CJ",
    "isCombo": false
  },
  {
    "value": "6 Pack Anywhere",
    "label": "6 Pack Anywhere",
    "otherNames": [
      "Crazy Six Pack",
      "Six Pack Anywhere",
      "Six Pack Abs"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "6 Pack Anywhere (Alternate)",
    "label": "6 Pack Anywhere (Alternate)",
    "otherNames": [
      "Six Pack Anywhere",
      "6 Pack Anywhere"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "6 Pack Anywhere (No Free Space)",
    "label": "6 Pack Anywhere (No Free Space)",
    "otherNames": [
      "Six Pack Anywhere (No Free Space)"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "6 Pack In Corner",
    "label": "6 Pack In Corner",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "7 - 11",
    "label": "7 - 11",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "7 - 11 (Alternate)",
    "label": "7 - 11 (Alternate)",
    "otherNames": [],
    "source": "numerical",
    "credit": "Alissa Wagoner",
    "isCombo": false
  },
  {
    "value": "7 Around 2 Corners - No Ns",
    "label": "7 Around 2 Corners - No Ns",
    "otherNames": [],
    "source": "numerical",
    "credit": "Richard Ortiz",
    "isCombo": false
  },
  {
    "value": "7 Around The Corner",
    "label": "7 Around The Corner",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "7 Number Inch Worm — Any 7 Numbers (Continuous)",
    "label": "7 Number Inch Worm — Any 7 Numbers (Continuous)",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "7 On Top and Bottom",
    "label": "7 On Top and Bottom",
    "otherNames": [
      "Seven on Top and Bottom"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "7 U Large Picture Frame",
    "label": "7 U Large Picture Frame",
    "otherNames": [],
    "source": "numerical",
    "credit": "Claire Bickel",
    "isCombo": false
  },
  {
    "value": "8 Anywhere - No Free Space",
    "label": "8 Anywhere - No Free Space",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "8 Dotes",
    "label": "8 Dotes",
    "otherNames": [
      "8 Dots"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "8 Middle",
    "label": "8 Middle",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "8 Pack As Shown",
    "label": "8 Pack As Shown",
    "otherNames": [
      "Eight Pack As Shown"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "8 Pack Anywhere",
    "label": "8 Pack Anywhere",
    "otherNames": [
      "Eight Pack Anywhere"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "8 Parallel",
    "label": "8 Parallel",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "9 Lower Left Corner",
    "label": "9 Lower Left Corner",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "9 Pack As Shown",
    "label": "9 Pack As Shown",
    "otherNames": [
      "Nine Pack As Shown"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "9 Pack Anywhere",
    "label": "9 Pack Anywhere",
    "otherNames": [
      "Nine Pack Anywhere",
      "Block Of Nine Anywhere",
      "9 Numbers Baseball"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "9 Pack Corners",
    "label": "9 Pack Corners",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "9 Pack Upper Right",
    "label": "9 Pack Upper Right",
    "otherNames": [],
    "source": "numerical",
    "credit": "Craig D Miller",
    "isCombo": false
  },
  {
    "value": "12 Pack As Shown",
    "label": "12 Pack As Shown",
    "otherNames": [
      "Twelve Pack As Shown"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "12 Pack Anywhere",
    "label": "12 Pack Anywhere",
    "otherNames": [
      "Twelve Pack Anywhere"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 0",
    "label": "Number 0",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 1",
    "label": "Number 1",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 1 (Alternate)",
    "label": "Number 1 (Alternate)",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 1 (Alternate 2)",
    "label": "Number 1 (Alternate 2)",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 1 (Alternate 3)",
    "label": "Number 1 (Alternate 3)",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 2",
    "label": "Number 2",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 2 (Alternate)",
    "label": "Number 2 (Alternate)",
    "otherNames": [],
    "source": "numerical",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Number 2 (Alternate 2)",
    "label": "Number 2 (Alternate 2)",
    "otherNames": [
      "Two"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 3",
    "label": "Number 3",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 3 (Alternate)",
    "label": "Number 3 (Alternate)",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 3 (Alternate 2)",
    "label": "Number 3 (Alternate 2)",
    "otherNames": [
      "Big 3",
      "Big Three",
      "Number Three"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 3 (Reversed)",
    "label": "Number 3 (Reversed)",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 4",
    "label": "Number 4",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 4 (Alternate)",
    "label": "Number 4 (Alternate)",
    "otherNames": [
      "4 H"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 4 (Alternate 2)",
    "label": "Number 4 (Alternate 2)",
    "otherNames": [],
    "source": "numerical",
    "credit": "Bee",
    "isCombo": false
  },
  {
    "value": "Number 4 (Alternate 3)",
    "label": "Number 4 (Alternate 3)",
    "otherNames": [],
    "source": "numerical",
    "credit": "Erica S",
    "isCombo": false
  },
  {
    "value": "Number 5",
    "label": "Number 5",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 5 (Alternate)",
    "label": "Number 5 (Alternate)",
    "otherNames": [],
    "source": "numerical",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Number 5 (Alternate 2)",
    "label": "Number 5 (Alternate 2)",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 6",
    "label": "Number 6",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 6 (Alternate)",
    "label": "Number 6 (Alternate)",
    "otherNames": [],
    "source": "numerical",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Number 7",
    "label": "Number 7",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 7 With Tail",
    "label": "Number 7 With Tail",
    "otherNames": [
      "Number 7 W/ Tail"
    ],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 8",
    "label": "Number 8",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 8 (Alternate)",
    "label": "Number 8 (Alternate)",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 8 (Alternate 2)",
    "label": "Number 8 (Alternate 2)",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 9",
    "label": "Number 9",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 9 (Alternate)",
    "label": "Number 9 (Alternate)",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 9 (Alternate 2)",
    "label": "Number 9 (Alternate 2)",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 10",
    "label": "Number 10",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 11",
    "label": "Number 11",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 11 (Alternate)",
    "label": "Number 11 (Alternate)",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 12",
    "label": "Number 12",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 13",
    "label": "Number 13",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 14",
    "label": "Number 14",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 15",
    "label": "Number 15",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 16",
    "label": "Number 16",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 17",
    "label": "Number 17",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 17 (Alternate)",
    "label": "Number 17 (Alternate)",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 18",
    "label": "Number 18",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 19",
    "label": "Number 19",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 19 (Alternate)",
    "label": "Number 19 (Alternate)",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 21",
    "label": "Number 21",
    "otherNames": [],
    "source": "numerical",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Number 25",
    "label": "Number 25",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 37",
    "label": "Number 37",
    "otherNames": [],
    "source": "numerical",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number 41",
    "label": "Number 41",
    "otherNames": [],
    "source": "numerical",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Number 51",
    "label": "Number 51",
    "otherNames": [],
    "source": "numerical",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Number 61",
    "label": "Number 61",
    "otherNames": [],
    "source": "numerical",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Accelerate",
    "label": "Accelerate",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Acorn",
    "label": "Acorn",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Add & Subtract",
    "label": "Add & Subtract",
    "otherNames": [
      "Add and Subtract"
    ],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Airplane",
    "label": "Airplane",
    "otherNames": [
      "Aeroplane",
      "Plane"
    ],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Airplane (Alternate)",
    "label": "Airplane (Alternate)",
    "otherNames": [],
    "source": "a",
    "credit": "Bob Versheck",
    "isCombo": false
  },
  {
    "value": "Airplane (Alternate 2)",
    "label": "Airplane (Alternate 2)",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "All Sides Through",
    "label": "All Sides Through",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "All The Way Down",
    "label": "All The Way Down",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Among Us",
    "label": "Among Us",
    "otherNames": [],
    "source": "a",
    "credit": "Jer",
    "isCombo": false
  },
  {
    "value": "Anchor",
    "label": "Anchor",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Anchor (Alternate)",
    "label": "Anchor (Alternate)",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Anchor (Alternate 2)",
    "label": "Anchor (Alternate 2)",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Anchor Me",
    "label": "Anchor Me",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Anchors Aweigh",
    "label": "Anchors Aweigh",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Angel Wings",
    "label": "Angel Wings",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Angled 3 Dots Anywhere",
    "label": "Angled 3 Dots Anywhere",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Antenna",
    "label": "Antenna",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Antler",
    "label": "Antler",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any 2 Outside Lines",
    "label": "Any 2 Outside Lines",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any 3 Tetrominoes",
    "label": "Any 3 Tetrominoes",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any 5 Straight Line Horizontal Or Vertical Except Free Space",
    "label": "Any 5 Straight Line Horizontal Or Vertical Except Free Space",
    "otherNames": [
      "Any Bingo - No Free Space",
      "Regular Bingo - No Free Space",
      "Hardway"
    ],
    "source": "a",
    "credit": "Charmagne Ilustrisimo",
    "isCombo": false
  },
  {
    "value": "Any Diagonal Line",
    "label": "Any Diagonal Line",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any Double Vertical And Horizontal Lines",
    "label": "Any Double Vertical And Horizontal Lines",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any 5 Around The Corner",
    "label": "Any 5 Around The Corner",
    "otherNames": [
      "Any Five Around The Corner",
      "Five Around The Corner",
      "5 Around The Corner Anywhere"
    ],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any Horizontal Line",
    "label": "Any Horizontal Line",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any Line",
    "label": "Any Line",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any Line (Alternate)",
    "label": "Any Line (Alternate)",
    "otherNames": [],
    "source": "a",
    "credit": "Adu",
    "isCombo": false
  },
  {
    "value": "Any Outside Line",
    "label": "Any Outside Line",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any 9 Numbers",
    "label": "Any 9 Numbers",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any Square",
    "label": "Any Square",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any Straight Line Not Diagonal",
    "label": "Any Straight Line Not Diagonal",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any Ten Numbers",
    "label": "Any Ten Numbers",
    "otherNames": [
      "Any 10 Numbers"
    ],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any Ten Spots, No Free Space)",
    "label": "Any Ten Spots, No Free Space",
    "otherNames": [
      "Any 10 Spots, No Free Space"
    ],
    "source": "a",
    "credit": "Alissa Wagoner",
    "isCombo": false
  },
  {
    "value": "Any Three Horizontal Lines (No Free Space)",
    "label": "Any Three Horizontal Lines (No Free Space)",
    "otherNames": [
      "Any Three Horizontal Lines Except Middle One"
    ],
    "source": "a",
    "credit": "Vipin Poulose",
    "isCombo": false
  },
  {
    "value": "Any Three Lines",
    "label": "Any Three Lines",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any Three Lines (Alternate)",
    "label": "Any Three Lines (Alternate)",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any Two Lines",
    "label": "Any Two Lines",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any Two Lines (Alternate)",
    "label": "Any Two Lines (Alternate)",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any Two Horizontal Lines",
    "label": "Any Two Horizontal Lines",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any Two Vertical Lines",
    "label": "Any Two Vertical Lines",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any Vertical Line",
    "label": "Any Vertical Line",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Any Vertical, Diagonal, Or Horizontal Line",
    "label": "Any Vertical, Diagonal, Or Horizontal Line",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Anyway",
    "label": "Anyway",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Arc En Ciel",
    "label": "Arc En Ciel",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Arrow",
    "label": "Arrow",
    "otherNames": [
      "Right Arrow"
    ],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Arrow (Alternate)",
    "label": "Arrow (Alternate)",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Arrow (Alternate 2)",
    "label": "Arrow (Alternate 2)",
    "otherNames": [
      "The Arrow"
    ],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Arrow Bottom Left Corner",
    "label": "Arrow Bottom Left Corner",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Arrow Bottom Left Corner (Alternate)",
    "label": "Arrow Bottom Left Corner (Alternate)",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Arrow Frame",
    "label": "Arrow Frame",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Arrowhead",
    "label": "Arrowhead",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Axe",
    "label": "Axe",
    "otherNames": [],
    "source": "a",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "B and I",
    "label": "B and I",
    "otherNames": [
      "B & I"
    ],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "B and O",
    "label": "B and O",
    "otherNames": [
      "B & O"
    ],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "B and O (Alternate)",
    "label": "B and O (Alternate)",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "B N O",
    "label": "B N O",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "B Straight",
    "label": "B Straight",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bs & Gs",
    "label": "Bs & Gs",
    "otherNames": [
      "Bs N Gs"
    ],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Baby Turtle",
    "label": "Baby Turtle",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bad Bingo  (Last Person With No Marks Is The Winner)",
    "label": "Bad Bingo  (Last Person With No Marks Is The Winner)",
    "otherNames": [
      "Last Person Standing",
      "Last Man Standing",
      "Last Woman Standing"
    ],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bacon and Eggs",
    "label": "Bacon and Eggs",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Ball",
    "label": "Ball",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Banana Split",
    "label": "Banana Split",
    "otherNames": [],
    "source": "b",
    "credit": "CJ",
    "isCombo": false
  },
  {
    "value": "Band O",
    "label": "Band O",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Baseball",
    "label": "Baseball",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Baseball Bat",
    "label": "Baseball Bat",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Baseball Stitches",
    "label": "Baseball Stitches",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Basket",
    "label": "Basket",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Basket (Alternate)",
    "label": "Basket (Alternate)",
    "otherNames": [],
    "source": "b",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Beach Umbrella",
    "label": "Beach Umbrella",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bed",
    "label": "Bed",
    "otherNames": [],
    "source": "b",
    "credit": "Patricia Morrison",
    "isCombo": false
  },
  {
    "value": "Bell",
    "label": "Bell",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bench",
    "label": "Bench",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "BIG",
    "label": "BIG",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Big A",
    "label": "Big A",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Big Dipper",
    "label": "Big Dipper",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Big G",
    "label": "Big G",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Big I",
    "label": "Big I",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Big Line",
    "label": "Big Line",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Big Three",
    "label": "Big Three",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Big V",
    "label": "Big V",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bike",
    "label": "Bike",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "BIN",
    "label": "BIN",
    "otherNames": [
      "B&I&N"
    ],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Binary Count",
    "label": "Binary Count",
    "otherNames": [],
    "source": "b",
    "credit": "Bob Versheck",
    "isCombo": false
  },
  {
    "value": "Bing Go",
    "label": "Bing Go",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bingo",
    "label": "Bingo",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bingo (Alternate)",
    "label": "Bingo (Alternate)",
    "otherNames": [],
    "source": "b",
    "credit": "Abdurasa",
    "isCombo": false
  },
  {
    "value": "Bingo (Alternate 2)",
    "label": "Bingo (Alternate 2)",
    "otherNames": [],
    "source": "b",
    "credit": "JOEANN",
    "isCombo": false
  },
  {
    "value": "B I O",
    "label": "B I O",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Birthday",
    "label": "Birthday",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Blackout",
    "label": "Blackout",
    "otherNames": [
      "Coverall",
      "Full Card",
      "Block Out",
      "Black Out"
    ],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Blast Seven",
    "label": "Blast Seven",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Block Of Six + Block Of Four",
    "label": "Block Of Six + Block Of Four",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Blood Drop",
    "label": "Blood Drop",
    "otherNames": [],
    "source": "b",
    "credit": "Rachel",
    "isCombo": false
  },
  {
    "value": "B,N,O Bingo",
    "label": "B,N,O Bingo",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bobbin",
    "label": "Bobbin",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bon-I",
    "label": "Bon-I",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Book",
    "label": "Book",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Boot",
    "label": "Boot",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bottom Half",
    "label": "Bottom Half",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bottom V",
    "label": "Bottom V",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bow",
    "label": "Bow",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bow and Arrow",
    "label": "Bow and Arrow",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bowling",
    "label": "Bowling",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bowling Lane",
    "label": "Bowling Lane",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bowtie",
    "label": "Bowtie",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bow Tie",
    "label": "Bow Tie",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bow Tie (Alternate)",
    "label": "Bow Tie (Alternate)",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bow Tie (Alternate 2)",
    "label": "Bow Tie (Alternate 2)",
    "otherNames": [],
    "source": "b",
    "credit": "Thalia",
    "isCombo": false
  },
  {
    "value": "Brackets",
    "label": "Brackets",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bridge And A Boat",
    "label": "Bridge And A Boat",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Broken Frame",
    "label": "Broken Frame",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Broom",
    "label": "Broom",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Broomstick",
    "label": "Broomstick",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Buckle",
    "label": "Buckle",
    "otherNames": [],
    "source": "b",
    "credit": "Khristy",
    "isCombo": false
  },
  {
    "value": "Buckle (Alternate)",
    "label": "Buckle (Alternate)",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Buckshot 10 — Any 10 Numbers — No Free Space",
    "label": "Buckshot 10 — Any 10 Numbers — No Free Space",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Buffalo",
    "label": "Buffalo",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bug",
    "label": "Bug",
    "otherNames": [],
    "source": "b",
    "credit": "Marianne Nissen",
    "isCombo": false
  },
  {
    "value": "Bullseye",
    "label": "Bullseye",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bunny",
    "label": "Bunny",
    "otherNames": [],
    "source": "b",
    "credit": "Lacey Sistaz",
    "isCombo": false
  },
  {
    "value": "Bunny (Alternate)",
    "label": "Bunny (Alternate)",
    "otherNames": [],
    "source": "b",
    "credit": "Lacey Sistaz",
    "isCombo": false
  },
  {
    "value": "Bunny Ears",
    "label": "Bunny Ears",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Bunny Ears (Alternate)",
    "label": "Bunny Ears (Alternate)",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Burst",
    "label": "Burst",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Butterfly",
    "label": "Butterfly",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Butterfly (Alternate)",
    "label": "Butterfly (Alternate)",
    "otherNames": [],
    "source": "b",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Cactus",
    "label": "Cactus",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Cactus (Arizona Style)",
    "label": "Cactus (Arizona Style)",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Cake Filling",
    "label": "Cake Filling",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Cancer and 2nd Pattern \"Reverse Contrast Cancer\"",
    "label": "Cancer and 2nd Pattern \"Reverse Contrast Cancer\"",
    "otherNames": [],
    "source": "c",
    "credit": "Paul Van Berkel",
    "isCombo": false
  },
  {
    "value": "Candlestick",
    "label": "Candlestick",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Candy",
    "label": "Candy",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Candy (Alternate)",
    "label": "Candy (Alternate)",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Candy Cane",
    "label": "Candy Cane",
    "otherNames": [],
    "source": "c",
    "credit": "Denise S",
    "isCombo": false
  },
  {
    "value": "Cannon",
    "label": "Cannon",
    "otherNames": [],
    "source": "c",
    "credit": "Evan O",
    "isCombo": false
  },
  {
    "value": "Capital C",
    "label": "Capital C",
    "otherNames": [],
    "source": "c",
    "credit": "Athan McFarland",
    "isCombo": false
  },
  {
    "value": "Car",
    "label": "Car",
    "otherNames": [],
    "source": "c",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Carton Lleno",
    "label": "Carton Lleno",
    "otherNames": [],
    "source": "c",
    "credit": "Andres",
    "isCombo": false
  },
  {
    "value": "Castle Wall",
    "label": "Castle Wall",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Catchers Mask",
    "label": "Catchers Mask",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Cc",
    "label": "Cc",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Cent Sign",
    "label": "Cent Sign",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Center",
    "label": "Center",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Chair",
    "label": "Chair",
    "otherNames": [],
    "source": "c",
    "credit": "Marlene Carnduff",
    "isCombo": false
  },
  {
    "value": "Chair (Alternate)",
    "label": "Chair (Alternate)",
    "otherNames": [],
    "source": "c",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Chair (Alternate 2)",
    "label": "Chair (Alternate 2)",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Champagne Glass",
    "label": "Champagne Glass",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Champagne Glass (Alternate)",
    "label": "Champagne Glass (Alternate)",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Chapel",
    "label": "Chapel",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Charity",
    "label": "Charity",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Checkerboard",
    "label": "Checkerboard",
    "otherNames": [
      "Checker Board"
    ],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Checkerboard (Reversed)",
    "label": "Checkerboard (Reversed)",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Checkmark",
    "label": "Checkmark",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Checkmark (Alternate)",
    "label": "Checkmark (Alternate)",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Check Mark",
    "label": "Check Mark",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Checkmark With Corner Stamp",
    "label": "Checkmark With Corner Stamp",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Cherries",
    "label": "Cherries",
    "otherNames": [],
    "source": "c",
    "credit": "Joey S",
    "isCombo": false
  },
  {
    "value": "Chess",
    "label": "Chess",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Chevron",
    "label": "Chevron",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Chevron + 2 Corners",
    "label": "Chevron + 2 Corners",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Chevron (Reversed)",
    "label": "Chevron (Reversed)",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Chevron Stripe W/ Free Space",
    "label": "Chevron Stripe W/ Free Space",
    "otherNames": [],
    "source": "c",
    "credit": "Allison D",
    "isCombo": false
  },
  {
    "value": "Chicken",
    "label": "Chicken",
    "otherNames": [],
    "source": "c",
    "credit": "The Bottom",
    "isCombo": false
  },
  {
    "value": "Chicken Dance",
    "label": "Chicken Dance",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Chihuahua",
    "label": "Chihuahua",
    "otherNames": [],
    "source": "c",
    "credit": "Jeremey Brooks",
    "isCombo": false
  },
  {
    "value": "Christmas Tree",
    "label": "Christmas Tree",
    "otherNames": [
      "Sapin de noel"
    ],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Christmas Tree (Alternate)",
    "label": "Christmas Tree (Alternate)",
    "otherNames": [
      "Sapin de noel"
    ],
    "source": "c",
    "credit": "Bret Rice",
    "isCombo": false
  },
  {
    "value": "Christmas Tree (Alternate 2)",
    "label": "Christmas Tree (Alternate 2)",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Clock",
    "label": "Clock",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Clock I",
    "label": "Clock I",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Clock II",
    "label": "Clock II",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Clock III",
    "label": "Clock III",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Clock IV",
    "label": "Clock IV",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Clog",
    "label": "Clog",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Clover",
    "label": "Clover",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Clover Leaf",
    "label": "Clover Leaf",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Cocktail",
    "label": "Cocktail",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Coffee Cup",
    "label": "Coffee Cup",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Coffee Mug",
    "label": "Coffee Mug",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Connector",
    "label": "Connector",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Corcho",
    "label": "Corcho",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Corn On The Cob",
    "label": "Corn On The Cob",
    "otherNames": [],
    "source": "c",
    "credit": "Louise Durgin",
    "isCombo": false
  },
  {
    "value": "Corner Triangle",
    "label": "Corner Triangle",
    "otherNames": [],
    "source": "c",
    "credit": "Richard Ortiz",
    "isCombo": false
  },
  {
    "value": "Corners",
    "label": "Corners",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Corners and Cross",
    "label": "Corners and Cross",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Coverall",
    "label": "Coverall",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crazy 7",
    "label": "Crazy 7",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crazy 8",
    "label": "Crazy 8",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crazy Arrow",
    "label": "Crazy Arrow",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crazy Arrowhead",
    "label": "Crazy Arrowhead",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crazy Bowtie",
    "label": "Crazy Bowtie",
    "otherNames": [],
    "source": "c",
    "credit": "Alissa Wagoner",
    "isCombo": false
  },
  {
    "value": "Crazy Chevron",
    "label": "Crazy Chevron",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crazy Chevron (Alternate)",
    "label": "Crazy Chevron (Alternate)",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crazy Kite",
    "label": "Crazy Kite",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crazy Kite (Alternate)",
    "label": "Crazy Kite (Alternate)",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crazy L",
    "label": "Crazy L",
    "otherNames": [
      "Big L",
      "Crazy Angle"
    ],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crazy Large Kite",
    "label": "Crazy Large Kite",
    "otherNames": [
      "Large Wild Kite"
    ],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crazy Pyramid",
    "label": "Crazy Pyramid",
    "otherNames": [
      "Triangle A"
    ],
    "source": "c",
    "credit": "Sangeeta",
    "isCombo": false
  },
  {
    "value": "Crazy Stamp (No Free)",
    "label": "Crazy Stamp (No Free)",
    "otherNames": [],
    "source": "c",
    "credit": "robert henry",
    "isCombo": false
  },
  {
    "value": "Crazy Stamp & Line",
    "label": "Crazy Stamp & Line",
    "otherNames": [
      "Crazy Stamp With 1 Line - May Overlap",
      "Stamp and a Line - Anywhere"
    ],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crazy T",
    "label": "Crazy T",
    "otherNames": [
      "Floating T",
      "Letter T (Roaming)"
    ],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crazy T Or L",
    "label": "Crazy T Or L",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crazy U",
    "label": "Crazy U",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crazy V",
    "label": "Crazy V",
    "otherNames": [],
    "source": "c",
    "credit": "Michael Mixell",
    "isCombo": false
  },
  {
    "value": "Cricket Stumps",
    "label": "Cricket Stumps",
    "otherNames": [],
    "source": "c",
    "credit": "Jackie Bremar",
    "isCombo": false
  },
  {
    "value": "Croquet",
    "label": "Croquet",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Cross",
    "label": "Cross",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Cross (Alternate)",
    "label": "Cross (Alternate)",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Cross (Alternate 2)",
    "label": "Cross (Alternate 2)",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Cross (Alternate 3)",
    "label": "Cross (Alternate 3)",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crossflags",
    "label": "Crossflags",
    "otherNames": [],
    "source": "c",
    "credit": "Alissa Wagoner",
    "isCombo": false
  },
  {
    "value": "Cross and Frame",
    "label": "Cross and Frame",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Cross Saber",
    "label": "Cross Saber",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Cross Stitch",
    "label": "Cross Stitch",
    "otherNames": [
      "Petite Croix"
    ],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crown",
    "label": "Crown",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Crown (Alternate)",
    "label": "Crown (Alternate)",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Cupcake",
    "label": "Cupcake",
    "otherNames": [],
    "source": "c",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Cupids Arrow",
    "label": "Cupids Arrow",
    "otherNames": [],
    "source": "c",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "D & M",
    "label": "D & M",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Daisy",
    "label": "Daisy",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Diagonal",
    "label": "Diagonal",
    "otherNames": [],
    "source": "d",
    "credit": "Nija",
    "isCombo": false
  },
  {
    "value": "Diagonal (Alternate)",
    "label": "Diagonal (Alternate)",
    "otherNames": [],
    "source": "d",
    "credit": "Jake",
    "isCombo": false
  },
  {
    "value": "Diagonal, Horizontal, Vertical, Or Four Corners",
    "label": "Diagonal, Horizontal, Vertical, Or Four Corners",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Diagonal And Inside Four Corners",
    "label": "Diagonal And Inside Four Corners",
    "otherNames": [],
    "source": "d",
    "credit": "Joe Pfanzelter",
    "isCombo": false
  },
  {
    "value": "Diagonal 'T' (Sorry No Free Space)",
    "label": "Diagonal 'T' (Sorry No Free Space)",
    "otherNames": [],
    "source": "d",
    "credit": "Thomas J.",
    "isCombo": false
  },
  {
    "value": "Diamond",
    "label": "Diamond",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Diamond (Alternate)",
    "label": "Diamond (Alternate)",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Diamond (Alternate 2)",
    "label": "Diamond (Alternate 2)",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Diamond (1 Away)",
    "label": "Diamond (1 Away)",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Diamond (With Free Space)",
    "label": "Diamond (With Free Space)",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Diamond Burst",
    "label": "Diamond Burst",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Diamond Filled",
    "label": "Diamond Filled",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Diamond Inside",
    "label": "Diamond Inside",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Diamond Plus 4 Corners",
    "label": "Diamond Plus 4 Corners",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Diamond Plus Any 2 Corners",
    "label": "Diamond Plus Any 2 Corners",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Diamond Ring",
    "label": "Diamond Ring",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Dice 5",
    "label": "Dice 5",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Division Symbol",
    "label": "Division Symbol",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Dog",
    "label": "Dog",
    "otherNames": [],
    "source": "d",
    "credit": "Michelle Langer",
    "isCombo": false
  },
  {
    "value": "Dog Bone",
    "label": "Dog Bone",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Dollar Bill",
    "label": "Dollar Bill",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Dollar Sign",
    "label": "Dollar Sign",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Dollar Sign (Alternate)",
    "label": "Dollar Sign (Alternate)",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Domino",
    "label": "Domino",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Dominoes",
    "label": "Dominoes",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Door",
    "label": "Door",
    "otherNames": [],
    "source": "d",
    "credit": "Eliza",
    "isCombo": false
  },
  {
    "value": "Double 4s",
    "label": "Double 4s",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Double Bingo (May Include 4 Corners)",
    "label": "Double Bingo (May Include 4 Corners)",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Double C",
    "label": "Double C",
    "otherNames": [],
    "source": "d",
    "credit": "Michelle Langer",
    "isCombo": false
  },
  {
    "value": "Double Cross",
    "label": "Double Cross",
    "otherNames": [],
    "source": "d",
    "credit": "MSDX",
    "isCombo": false
  },
  {
    "value": "Double Frame",
    "label": "Double Frame",
    "otherNames": [],
    "source": "d",
    "credit": "Michelle Langer",
    "isCombo": false
  },
  {
    "value": "Double I",
    "label": "Double I",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Double Ribbons (Best Friends With Or Without Cancer)",
    "label": "Double Ribbons (Best Friends With Or Without Cancer)",
    "otherNames": [],
    "source": "d",
    "credit": "Rosa Lara",
    "isCombo": false
  },
  {
    "value": "Double Stamp",
    "label": "Double Stamp",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Dos Bingo",
    "label": "Dos Bingo",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Dot 8",
    "label": "Dot 8",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Dot 14",
    "label": "Dot 14",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Double Bingo",
    "label": "Double Bingo",
    "otherNames": [
      "Two Bingos",
      "2 Bingos"
    ],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Double Chevron",
    "label": "Double Chevron",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Double 6 Pack",
    "label": "Double 6 Pack",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Double L",
    "label": "Double L",
    "otherNames": [],
    "source": "d",
    "credit": "Craig D Miller",
    "isCombo": false
  },
  {
    "value": "Double L (Alternate)",
    "label": "Double L (Alternate)",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Double L (Alternate 2)",
    "label": "Double L (Alternate 2)",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Double Plus",
    "label": "Double Plus",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Double Triple Dot",
    "label": "Double Triple Dot",
    "otherNames": [],
    "source": "d",
    "credit": "Alissa Wagoner",
    "isCombo": false
  },
  {
    "value": "Double X",
    "label": "Double X",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Down",
    "label": "Down",
    "otherNames": [],
    "source": "d",
    "credit": "Convivial Kendrea",
    "isCombo": false
  },
  {
    "value": "Down Arrow",
    "label": "Down Arrow",
    "otherNames": [
      "South Arrow"
    ],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Dragonfly",
    "label": "Dragonfly",
    "otherNames": [],
    "source": "d",
    "credit": "Adrienne",
    "isCombo": false
  },
  {
    "value": "Dragonfly (Alternate)",
    "label": "Dragonfly (Alternate)",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Dragonfly (Alternate 2)",
    "label": "Dragonfly (Alternate 2)",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Dreidel",
    "label": "Dreidel",
    "otherNames": [],
    "source": "d",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Easter Basket",
    "label": "Easter Basket",
    "otherNames": [],
    "source": "e",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Edges",
    "label": "Edges",
    "otherNames": [],
    "source": "e",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Elk",
    "label": "Elk",
    "otherNames": [],
    "source": "e",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Empty Champagne Glass",
    "label": "Empty Champagne Glass",
    "otherNames": [],
    "source": "e",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Equal Sign",
    "label": "Equal Sign",
    "otherNames": [],
    "source": "e",
    "credit": "Jordon",
    "isCombo": false
  },
  {
    "value": "Explosion",
    "label": "Explosion",
    "otherNames": [],
    "source": "e",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Falling Snow",
    "label": "Falling Snow",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Ferris Wheel",
    "label": "Ferris Wheel",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Field Goal",
    "label": "Field Goal",
    "otherNames": [
      "Goal Post"
    ],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Field Goal (Alternate)",
    "label": "Field Goal (Alternate)",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Finals",
    "label": "Finals",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Fire Hydrant",
    "label": "Fire Hydrant",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Firecracker",
    "label": "Firecracker",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Fireplace",
    "label": "Fireplace",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Fireworks Display",
    "label": "Fireworks Display",
    "otherNames": [],
    "source": "f",
    "credit": "Nico",
    "isCombo": false
  },
  {
    "value": "First 5",
    "label": "First 5",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Fish",
    "label": "Fish",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Fish Hook",
    "label": "Fish Hook",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Fishing Rod",
    "label": "Fishing Rod",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Flag",
    "label": "Flag",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Flag (Alternate 2)",
    "label": "Flag (Alternate 2)",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Flag Pole",
    "label": "Flag Pole",
    "otherNames": [
      "Flag"
    ],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Flag Pole (Alternate)",
    "label": "Flag Pole (Alternate)",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Flag (Reversed)",
    "label": "Flag (Reversed)",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Floating Block Of Nine",
    "label": "Floating Block Of Nine",
    "otherNames": [],
    "source": "f",
    "credit": "Selena A Falcon",
    "isCombo": false
  },
  {
    "value": "Flower",
    "label": "Flower",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Flower (Alternate)",
    "label": "Flower (Alternate)",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Fly And Swatter",
    "label": "Fly And Swatter",
    "otherNames": [],
    "source": "f",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Fly Swatter & Fly Right",
    "label": "Fly Swatter & Fly Right",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Flying Kites",
    "label": "Flying Kites",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Football",
    "label": "Football",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Football Jersey",
    "label": "Football Jersey",
    "otherNames": [],
    "source": "f",
    "credit": "Christina Ruth",
    "isCombo": false
  },
  {
    "value": "Four Arrows",
    "label": "Four Arrows",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Four Corners",
    "label": "Four Corners",
    "otherNames": [
      "4 Corners",
      "Box"
    ],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Four Corners Small",
    "label": "Four Corners Small",
    "otherNames": [
      "Inside Square",
      "Dots Four"
    ],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Four Dots - Horizontal/Vertical",
    "label": "Four Dots - Horizontal/Vertical",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Fortress",
    "label": "Fortress",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Frankenstein",
    "label": "Frankenstein",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Free",
    "label": "Free",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Free Space Bingo",
    "label": "Free Space Bingo",
    "otherNames": [],
    "source": "f",
    "credit": "Jim Stalker",
    "isCombo": false
  },
  {
    "value": "Free Space Centers",
    "label": "Free Space Centers",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Frown",
    "label": "Frown",
    "otherNames": [],
    "source": "f",
    "credit": "Daisy",
    "isCombo": false
  },
  {
    "value": "Frowny Face",
    "label": "Frowny Face",
    "otherNames": [],
    "source": "f",
    "credit": "Richard Ortiz ",
    "isCombo": false
  },
  {
    "value": "Fruit Basket",
    "label": "Fruit Basket",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Full 4",
    "label": "Full 4",
    "otherNames": [],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Full Hourglass",
    "label": "Full Hourglass",
    "otherNames": [
      "Damro"
    ],
    "source": "f",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "G Straight",
    "label": "G Straight",
    "otherNames": [],
    "source": "g",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Gift",
    "label": "Gift",
    "otherNames": [],
    "source": "g",
    "credit": "Denise S",
    "isCombo": false
  },
  {
    "value": "Ghost",
    "label": "Ghost",
    "otherNames": [],
    "source": "g",
    "credit": "Patricia Morrison",
    "isCombo": false
  },
  {
    "value": "Ghost (Alternate)",
    "label": "Ghost (Alternate)",
    "otherNames": [],
    "source": "g",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "GO",
    "label": "GO",
    "otherNames": [],
    "source": "g",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Goal Post",
    "label": "Goal Post",
    "otherNames": [],
    "source": "g",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Goal Post (Alternate)",
    "label": "Goal Post (Alternate)",
    "otherNames": [],
    "source": "g",
    "credit": "Joe Pfanzelter",
    "isCombo": false
  },
  {
    "value": "Golden 8",
    "label": "Golden 8",
    "otherNames": [],
    "source": "g",
    "credit": "MSDX",
    "isCombo": false
  },
  {
    "value": "Golden 8 (Alternate)",
    "label": "Golden 8 (Alternate)",
    "otherNames": [],
    "source": "g",
    "credit": "Jass",
    "isCombo": false
  },
  {
    "value": "Golden 8 Bingo",
    "label": "Golden 8 Bingo",
    "otherNames": [],
    "source": "g",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Golf Bag",
    "label": "Golf Bag",
    "otherNames": [],
    "source": "g",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Golf Club & Ball",
    "label": "Golf Club & Ball",
    "otherNames": [],
    "source": "g",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Golf Club & Ball (Reversed)",
    "label": "Golf Club & Ball (Reversed)",
    "otherNames": [],
    "source": "g",
    "credit": "Joy",
    "isCombo": false
  },
  {
    "value": "Grass",
    "label": "Grass",
    "otherNames": [],
    "source": "g",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Greater",
    "label": "Greater",
    "otherNames": [],
    "source": "g",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Growing That Pot Leaf",
    "label": "Growing That Pot Leaf",
    "otherNames": [],
    "source": "g",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Half Hearted",
    "label": "Half Hearted",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Half Moon",
    "label": "Half Moon",
    "otherNames": [],
    "source": "h",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Half Moon (Alternate)",
    "label": "Half Moon (Alternate)",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Halloween",
    "label": "Halloween",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hammer",
    "label": "Hammer",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hammer Head T",
    "label": "Hammer Head T",
    "otherNames": [
      "Telephone Pole"
    ],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hammock",
    "label": "Hammock",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hand Stand",
    "label": "Hand Stand",
    "otherNames": [],
    "source": "h",
    "credit": "Lindsey J",
    "isCombo": false
  },
  {
    "value": "Handlebar Moustache",
    "label": "Handlebar Moustache",
    "otherNames": [],
    "source": "h",
    "credit": "Tony Spin",
    "isCombo": false
  },
  {
    "value": "Hang The Caller",
    "label": "Hang The Caller",
    "otherNames": [],
    "source": "h",
    "credit": "Cyril Kirkland",
    "isCombo": false
  },
  {
    "value": "Hanger",
    "label": "Hanger",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hangman",
    "label": "Hangman",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hangman (Alternate)",
    "label": "Hangman (Alternate)",
    "otherNames": [],
    "source": "h",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Hanukkah - Hay",
    "label": "Hanukkah - Hay",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hanukkah - Menorah",
    "label": "Hanukkah - Menorah",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hanukkah - Dreidel",
    "label": "Hanukkah - Dreidel",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Happy Face",
    "label": "Happy Face",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Happy Face (Alternate)",
    "label": "Happy Face (Alternate)",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hardway",
    "label": "Hardway",
    "otherNames": [
      "Any Bingo - No Free Space",
      "Regular Bingo - No Free Space",
      "Any 5 Straight Line Horizontal Or Vertical Except Free Space"
    ],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hardway Stamp",
    "label": "Hardway Stamp",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hardway Triple",
    "label": "Hardway Triple",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hard Way Triple Dot No Diagonals",
    "label": "Hard Way Triple Dot No Diagonals",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hart",
    "label": "Hart",
    "otherNames": [],
    "source": "h",
    "credit": "carisia",
    "isCombo": false
  },
  {
    "value": "Hash Marks",
    "label": "Hash Marks",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hashtag",
    "label": "Hashtag",
    "otherNames": [],
    "source": "h",
    "credit": "Kevin F",
    "isCombo": false
  },
  {
    "value": "Hat",
    "label": "Hat",
    "otherNames": [],
    "source": "h",
    "credit": "Trish",
    "isCombo": false
  },
  {
    "value": "Headphones",
    "label": "Headphones",
    "otherNames": [],
    "source": "h",
    "credit": "Lindsey J",
    "isCombo": false
  },
  {
    "value": "Heart",
    "label": "Heart",
    "otherNames": [
      "Heart2heart"
    ],
    "source": "h",
    "credit": "Michele Davis",
    "isCombo": false
  },
  {
    "value": "Heart (Alternate)",
    "label": "Heart (Alternate)",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Heart (Alternate 2)",
    "label": "Heart (Alternate 2)",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Heart (Alternate 3)",
    "label": "Heart (Alternate 3)",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Heart (Alternate 4)",
    "label": "Heart (Alternate 4)",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Heartbeat",
    "label": "Heartbeat",
    "otherNames": [],
    "source": "h",
    "credit": "Patricia Morrison",
    "isCombo": false
  },
  {
    "value": "Hearts Of Love",
    "label": "Hearts Of Love",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Helmet",
    "label": "Helmet",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hi",
    "label": "Hi",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hi (Alternate)",
    "label": "Hi (Alternate)",
    "otherNames": [],
    "source": "h",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Highway",
    "label": "Highway",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hippo Head",
    "label": "Hippo Head",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hockey Sticks",
    "label": "Hockey Sticks",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hole in the wall",
    "label": "Hole in the wall",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Home",
    "label": "Home",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Home Plate",
    "label": "Home Plate",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Home Plate (Alternate)",
    "label": "Home Plate (Alternate)",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Honor Flight",
    "label": "Honor Flight",
    "otherNames": [],
    "source": "h",
    "credit": "Kathy Spielman",
    "isCombo": false
  },
  {
    "value": "Horizontal",
    "label": "Horizontal",
    "otherNames": [
      "Any Row"
    ],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Horizontal Plus N",
    "label": "Horizontal Plus N",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Horse Head",
    "label": "Horse Head",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Horseshoe",
    "label": "Horseshoe",
    "otherNames": [],
    "source": "h",
    "credit": "Rebecca",
    "isCombo": false
  },
  {
    "value": "Horse Shoes",
    "label": "Horse Shoes",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Horizontal Center",
    "label": "Horizontal Center",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hot Dog In A Bun",
    "label": "Hot Dog In A Bun",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hourglass",
    "label": "Hourglass",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hourglass Top",
    "label": "Hourglass Top",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Hourglass Bottom",
    "label": "Hourglass Bottom",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "House",
    "label": "House",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "House (Alternate)",
    "label": "House (Alternate)",
    "otherNames": [],
    "source": "h",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "House (Alternate 2)",
    "label": "House (Alternate 2)",
    "otherNames": [],
    "source": "h",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Huggie",
    "label": "Huggie",
    "otherNames": [],
    "source": "h",
    "credit": "Tenayla",
    "isCombo": false
  },
  {
    "value": "Icicle",
    "label": "Icicle",
    "otherNames": [],
    "source": "i",
    "credit": "Krista P",
    "isCombo": false
  },
  {
    "value": "Icicles",
    "label": "Icicles",
    "otherNames": [],
    "source": "i",
    "credit": "Christina Ruth",
    "isCombo": false
  },
  {
    "value": "If",
    "label": "If",
    "otherNames": [],
    "source": "i",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Infinity",
    "label": "Infinity",
    "otherNames": [],
    "source": "i",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "ING Game",
    "label": "ING Game",
    "otherNames": [],
    "source": "i",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "In Or Out",
    "label": "In Or Out",
    "otherNames": [],
    "source": "i",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Inside Corners & A Bingo",
    "label": "Inside Corners & A Bingo",
    "otherNames": [],
    "source": "i",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Inverted Big V",
    "label": "Inverted Big V",
    "otherNames": [],
    "source": "i",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "I Straight",
    "label": "I Straight",
    "otherNames": [],
    "source": "i",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "It",
    "label": "It",
    "otherNames": [],
    "source": "i",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Jambalaya (All But One Line)",
    "label": "Jambalaya (All But One Line)",
    "otherNames": [],
    "source": "j",
    "credit": "CJ",
    "isCombo": false
  },
  {
    "value": "Jamboree",
    "label": "Jamboree",
    "otherNames": [],
    "source": "j",
    "credit": "Alissa Wagoner",
    "isCombo": false
  },
  {
    "value": "Jamboree On 4 Cards",
    "label": "Jamboree On 4 Cards",
    "otherNames": [],
    "source": "j",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Jesus Fish",
    "label": "Jesus Fish",
    "otherNames": [],
    "source": "j",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Jl",
    "label": "Jl",
    "otherNames": [],
    "source": "j",
    "credit": "bob",
    "isCombo": false
  },
  {
    "value": "Key",
    "label": "Key",
    "otherNames": [],
    "source": "k",
    "credit": "Katie Steulke",
    "isCombo": false
  },
  {
    "value": "Kite",
    "label": "Kite",
    "otherNames": [],
    "source": "k",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Kite (Alternate)",
    "label": "Kite (Alternate)",
    "otherNames": [],
    "source": "k",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Kite (Alternate 2)",
    "label": "Kite (Alternate 2)",
    "otherNames": [],
    "source": "k",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Krazy Kanr",
    "label": "Krazy Kanr",
    "otherNames": [],
    "source": "k",
    "credit": "Michele",
    "isCombo": false
  },
  {
    "value": "Lacrosse Goal",
    "label": "Lacrosse Goal",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Ladder",
    "label": "Ladder",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Lady Bug",
    "label": "Lady Bug",
    "otherNames": [],
    "source": "l",
    "credit": "Lindsey J",
    "isCombo": false
  },
  {
    "value": "Large Frame",
    "label": "Large Frame",
    "otherNames": [
      "Outer Border",
      "Outside Frame"
    ],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Large Kite",
    "label": "Large Kite",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Large Ladder",
    "label": "Large Ladder",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Layer Cake",
    "label": "Layer Cake",
    "otherNames": [
      "Sandwich"
    ],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Leaf",
    "label": "Leaf",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Leaf (Alternate)",
    "label": "Leaf (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Lederhosen",
    "label": "Lederhosen",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Left",
    "label": "Left",
    "otherNames": [],
    "source": "l",
    "credit": "Convivial Kendrea",
    "isCombo": false
  },
  {
    "value": "Left Arrow",
    "label": "Left Arrow",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter A",
    "label": "Letter A",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter A (Alternate)",
    "label": "Letter A (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter A (Alternate 2)",
    "label": "Letter A (Alternate 2)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter A (Alternate 3)",
    "label": "Letter A (Alternate 3)",
    "otherNames": [
      "Power A"
    ],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter A (Alternate 4)",
    "label": "Letter A (Alternate 4)",
    "otherNames": [
      "A"
    ],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter A (Alternate 5)",
    "label": "Letter A (Alternate 5)",
    "otherNames": [],
    "source": "l",
    "credit": "Denise",
    "isCombo": false
  },
  {
    "value": "Letter A (Alternate 6)",
    "label": "Letter A (Alternate 6)",
    "otherNames": [],
    "source": "l",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Letter A (Alternate 7)",
    "label": "Letter A (Alternate 7)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter B",
    "label": "Letter B",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter B (Alternate)",
    "label": "Letter B (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter B (Alternate 2)",
    "label": "Letter B (Alternate 2)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter B (Alternate 3)",
    "label": "Letter B (Alternate 3)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter B (Alternate 4)",
    "label": "Letter B (Alternate 4)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter B (Alternate 5)",
    "label": "Letter B (Alternate 5)",
    "otherNames": [
      "Botanica \"B\""
    ],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter B (Alternate 6)",
    "label": "Letter B (Alternate 6)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter C",
    "label": "Letter C",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter C (Alternate)",
    "label": "Letter C (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter C (Alternate 2)",
    "label": "Letter C (Alternate 2)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter C (Alternate 3)",
    "label": "Letter C (Alternate 3)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter D",
    "label": "Letter D",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter D (Alternate)",
    "label": "Letter D (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter E",
    "label": "Letter E",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter E (Alternate)",
    "label": "Letter E (Alternate)",
    "otherNames": [
      "Enhanced"
    ],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter E (Alternate 2)",
    "label": "Letter E (Alternate 2)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter E (Alternate 3)",
    "label": "Letter E (Alternate 3)",
    "otherNames": [
      "E"
    ],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter E (Reversed)",
    "label": "Letter E (Reversed)",
    "otherNames": [],
    "source": "l",
    "credit": "Claire Bickel",
    "isCombo": false
  },
  {
    "value": "Letter E (Small)",
    "label": "Letter E (Small)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter E Bottom Up",
    "label": "Letter E Bottom Up",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter E Upside Down",
    "label": "Letter E Upside Down",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter F",
    "label": "Letter F",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter F (Alternate)",
    "label": "Letter F (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": "Frank",
    "isCombo": false
  },
  {
    "value": "Letter F (Alternate 2)",
    "label": "Letter F (Alternate 2)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter F (Alternate 3)",
    "label": "Letter F (Alternate 3)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter F (Alternate 4)",
    "label": "Letter F (Alternate 4)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter F (Alternate 5)",
    "label": "Letter F (Alternate 5)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter G",
    "label": "Letter G",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter G (Alternate)",
    "label": "Letter G (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter G (Alternate 2)",
    "label": "Letter G (Alternate 2)",
    "otherNames": [],
    "source": "l",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Letter G (Alternate 3)",
    "label": "Letter G (Alternate 3)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter H",
    "label": "Letter H",
    "otherNames": [
      "Power H"
    ],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter H (Alternate)",
    "label": "Letter H (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": "Jessica",
    "isCombo": false
  },
  {
    "value": "Letter H (Alternate 2)",
    "label": "Letter H (Alternate 2)",
    "otherNames": [],
    "source": "l",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Letter I",
    "label": "Letter I",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter I (Alternate)",
    "label": "Letter I (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter I (Alternate 2)",
    "label": "Letter I (Alternate 2)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter J",
    "label": "Letter J",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter J (Alternate)",
    "label": "Letter J (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter J (Alternate 2)",
    "label": "Letter J (Alternate 2)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter J (Alternate 3)",
    "label": "Letter J (Alternate 3)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter J (Alternate 4)",
    "label": "Letter J (Alternate 4)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter J (Alternate 5)",
    "label": "Letter J (Alternate 5)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter K",
    "label": "Letter K",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter K (Alternate)",
    "label": "Letter K (Alternate)",
    "otherNames": [
      "K.E. K"
    ],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter K (Alternate 2)",
    "label": "Letter K (Alternate 2)",
    "otherNames": [],
    "source": "l",
    "credit": "Louise Durgin",
    "isCombo": false
  },
  {
    "value": "Letter K (Alternate 3)",
    "label": "Letter K (Alternate 3)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter L",
    "label": "Letter L",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter L (Alternate)",
    "label": "Letter L (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": "Ruth ONeal",
    "isCombo": false
  },
  {
    "value": "Letter L (Alternate 2)",
    "label": "Letter L (Alternate 2)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter L (Alternate 3)",
    "label": "Letter L (Alternate 3)",
    "otherNames": [],
    "source": "l",
    "credit": "Denise",
    "isCombo": false
  },
  {
    "value": "Letter M",
    "label": "Letter M",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter M (Alternate)",
    "label": "Letter M (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter M (Alternate 2)",
    "label": "Letter M (Alternate 2)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter N",
    "label": "Letter N",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter N (Alternate)",
    "label": "Letter N (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter N (Reversed)",
    "label": "Letter N (Reversed)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter O",
    "label": "Letter O",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter O (Alternate)",
    "label": "Letter O (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter P",
    "label": "Letter P",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter P (Alternate)",
    "label": "Letter P (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter P (Alternate 2)",
    "label": "Letter P (Alternate 2)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter P (Alternate 3)",
    "label": "Letter P (Alternate 3)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter P (Alternate 4)",
    "label": "Letter P (Alternate 4)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter P (Alternate 5)",
    "label": "Letter P (Alternate 5)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter Q",
    "label": "Letter Q",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter Q (Alternate)",
    "label": "Letter Q (Alternate)",
    "otherNames": [
      "Susie Q"
    ],
    "source": "l",
    "credit": "Richard Ortiz",
    "isCombo": false
  },
  {
    "value": "Letter R",
    "label": "Letter R",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter R (Alternate)",
    "label": "Letter R (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter R (Alternate 2)",
    "label": "Letter R (Alternate 2)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter R (Alternate 3)",
    "label": "Letter R (Alternate 3)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter R (Alternate 4)",
    "label": "Letter R (Alternate 4)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter R (Alternate 5)",
    "label": "Letter R (Alternate 5)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter R (Alternate 6)",
    "label": "Letter R (Alternate 6)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter S",
    "label": "Letter S",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter S (Alternate)",
    "label": "Letter S (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": "JPIA",
    "isCombo": false
  },
  {
    "value": "Letter S (Alternate 2)",
    "label": "Letter S (Alternate 2)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter S (Alternate 3)",
    "label": "Letter S (Alternate 3)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter S (Alternate 4)",
    "label": "Letter S (Alternate 4)",
    "otherNames": [],
    "source": "l",
    "credit": "Denise",
    "isCombo": false
  },
  {
    "value": "Letter S (Alternat 5)",
    "label": "Letter S (Alternate 5)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter S (Reversed)",
    "label": "Letter S (Reversed)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter T",
    "label": "Letter T",
    "otherNames": [
      "Pattern T"
    ],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter T (Alternate)",
    "label": "Letter T (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter U",
    "label": "Letter U",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter U (Alternate)",
    "label": "Letter U (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter V",
    "label": "Letter V",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter W",
    "label": "Letter W",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter W (Alternate)",
    "label": "Letter W (Alternate)",
    "otherNames": [
      "Hard W, W Pattern"
    ],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter W (Alternate 2)",
    "label": "Letter W (Alternate 2)",
    "otherNames": [
      "W",
      "Letter W"
    ],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter W (Alternate 3)",
    "label": "Letter W (Alternate 3)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter X",
    "label": "Letter X",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter X and Frame",
    "label": "Letter X and Frame",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter X and N Row",
    "label": "Letter X and N Row",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter X One Away",
    "label": "Letter X One Away",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter Y",
    "label": "Letter Y",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter Z",
    "label": "Letter Z",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Letter Z (Reversed)",
    "label": "Letter Z (Reversed)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Liberty Bell",
    "label": "Liberty Bell",
    "otherNames": [],
    "source": "l",
    "credit": "Jackie M.",
    "isCombo": false
  },
  {
    "value": "Light Bulb",
    "label": "Light Bulb",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Lightning",
    "label": "Lightning",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Line & Box",
    "label": "Line & Box",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Line, 4 Corners or a Stamp",
    "label": "Line, 4 Corners or a Stamp",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Line & 4 Corners (Anywhere)",
    "label": "Line & 4 Corners (Anywhere)",
    "otherNames": [],
    "source": "l",
    "credit": "Myrna",
    "isCombo": false
  },
  {
    "value": "Line Collection",
    "label": "Line Collection",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Line With Stamp Anywhere",
    "label": "Line With Stamp Anywhere",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Little Brown Jug",
    "label": "Little Brown Jug",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Little Cross",
    "label": "Little Cross",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Lobster",
    "label": "Lobster",
    "otherNames": [],
    "source": "l",
    "credit": "Louise Durgin",
    "isCombo": false
  },
  {
    "value": "Long Boot",
    "label": "Long Boot",
    "otherNames": [],
    "source": "l",
    "credit": "Tabitha ❤️",
    "isCombo": false
  },
  {
    "value": "Long Horn",
    "label": "Long Horn",
    "otherNames": [],
    "source": "l",
    "credit": "Denise Silnes",
    "isCombo": false
  },
  {
    "value": "Loop The Loop (Short)",
    "label": "Loop The Loop (Short)",
    "otherNames": [],
    "source": "l",
    "credit": "CJ",
    "isCombo": false
  },
  {
    "value": "Loop The Loop (Tall)",
    "label": "Loop The Loop (Tall)",
    "otherNames": [],
    "source": "l",
    "credit": "CJ",
    "isCombo": false
  },
  {
    "value": "Louis Vuitton",
    "label": "Louis Vuitton",
    "otherNames": [],
    "source": "l",
    "credit": "Kristie W",
    "isCombo": false
  },
  {
    "value": "Love Letter",
    "label": "Love Letter",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Love You",
    "label": "Love You",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Lucky 5",
    "label": "Lucky 5",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Lucky 7",
    "label": "Lucky 7",
    "otherNames": [
      "Seven One Direction",
      "7"
    ],
    "source": "l",
    "credit": "Carrie Negron",
    "isCombo": false
  },
  {
    "value": "Lucky 7 (Alternate)",
    "label": "Lucky 7 (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Lucky 7 (Alternate 2)",
    "label": "Lucky 7 (Alternate 2)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Lucky Frame",
    "label": "Lucky Frame",
    "otherNames": [],
    "source": "l",
    "credit": "MSDX",
    "isCombo": false
  },
  {
    "value": "Lucky Frame (Alternate)",
    "label": "Lucky Frame (Alternate)",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Lucky Star",
    "label": "Lucky Star",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Lumen",
    "label": "Lumen",
    "otherNames": [],
    "source": "l",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Mail",
    "label": "Mail",
    "otherNames": [],
    "source": "m",
    "credit": "CJ",
    "isCombo": false
  },
  {
    "value": "Make A Basket",
    "label": "Make A Basket",
    "otherNames": [],
    "source": "m",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Maple Leaf",
    "label": "Maple Leaf",
    "otherNames": [],
    "source": "m",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Margarita",
    "label": "Margarita",
    "otherNames": [],
    "source": "m",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Martini Glass",
    "label": "Martini Glass",
    "otherNames": [],
    "source": "m",
    "credit": "Richard Ortiz",
    "isCombo": false
  },
  {
    "value": "Medallion",
    "label": "Medallion",
    "otherNames": [],
    "source": "m",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Merry Go-Round",
    "label": "Merry Go-Round",
    "otherNames": [],
    "source": "m",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Mickey Mouse",
    "label": "Mickey Mouse",
    "otherNames": [],
    "source": "m",
    "credit": "Veronica Osuna",
    "isCombo": false
  },
  {
    "value": "Middle Exe",
    "label": "Middle Exe",
    "otherNames": [],
    "source": "m",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Midnight",
    "label": "Midnight",
    "otherNames": [],
    "source": "m",
    "credit": "Denise S",
    "isCombo": false
  },
  {
    "value": "Mini Blackout",
    "label": "Mini Blackout",
    "otherNames": [],
    "source": "m",
    "credit": "Claire Bickel",
    "isCombo": false
  },
  {
    "value": "Mini Blackout (Alternate)",
    "label": "Mini Blackout (Alternate)",
    "otherNames": [],
    "source": "m",
    "credit": "Claire Bickel",
    "isCombo": false
  },
  {
    "value": "Missing Link",
    "label": "Missing Link",
    "otherNames": [],
    "source": "m",
    "credit": "Alissa Wagoner",
    "isCombo": false
  },
  {
    "value": "Missing Link (Alternate)",
    "label": "Missing Link (Alternate)",
    "otherNames": [],
    "source": "m",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Mitten",
    "label": "Mitten",
    "otherNames": [],
    "source": "m",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Mitten (Alternate)",
    "label": "Mitten (Alternate)",
    "otherNames": [],
    "source": "m",
    "credit": "Christina Ruth",
    "isCombo": false
  },
  {
    "value": "Monarch",
    "label": "Monarch",
    "otherNames": [],
    "source": "m",
    "credit": "Rosa Lara",
    "isCombo": false
  },
  {
    "value": "Mond",
    "label": "Mond",
    "otherNames": [],
    "source": "m",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Monkey",
    "label": "Monkey",
    "otherNames": [],
    "source": "m",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Moon",
    "label": "Moon",
    "otherNames": [],
    "source": "m",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Moon (Alternate)",
    "label": "Moon (Alternate)",
    "otherNames": [],
    "source": "m",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Mothers Day",
    "label": "Mothers Day",
    "otherNames": [],
    "source": "m",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Moustache",
    "label": "Moustache",
    "otherNames": [],
    "source": "m",
    "credit": "Tony Spin",
    "isCombo": false
  },
  {
    "value": "Mug",
    "label": "Mug",
    "otherNames": [],
    "source": "m",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Muscle Man",
    "label": "Muscle Man",
    "otherNames": [],
    "source": "m",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Mushroom",
    "label": "Mushroom",
    "otherNames": [],
    "source": "m",
    "credit": "Marianne Nissen",
    "isCombo": false
  },
  {
    "value": "Music Note (Alternate)",
    "label": "Music Note (Alternate)",
    "otherNames": [],
    "source": "m",
    "credit": "Lindsey J",
    "isCombo": false
  },
  {
    "value": "Music Note",
    "label": "Music Note",
    "otherNames": [],
    "source": "m",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Mustache",
    "label": "Mustache",
    "otherNames": [],
    "source": "m",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "My",
    "label": "My",
    "otherNames": [],
    "source": "m",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "N",
    "label": "N",
    "otherNames": [],
    "source": "n",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "NO",
    "label": "NO",
    "otherNames": [],
    "source": "n",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "No Sign",
    "label": "No Sign",
    "otherNames": [],
    "source": "n",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "North Star",
    "label": "North Star",
    "otherNames": [],
    "source": "n",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Number Sign",
    "label": "Number Sign",
    "otherNames": [],
    "source": "n",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "O",
    "label": "O",
    "otherNames": [],
    "source": "o",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "O And P",
    "label": "O And P",
    "otherNames": [],
    "source": "o",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "O69",
    "label": "O69",
    "otherNames": [],
    "source": "o",
    "credit": "TOM",
    "isCombo": false
  },
  {
    "value": "Obtuse Angle",
    "label": "Obtuse Angle",
    "otherNames": [],
    "source": "o",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Ok",
    "label": "Ok",
    "otherNames": [],
    "source": "o",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Okay",
    "label": "Okay",
    "otherNames": [],
    "source": "o",
    "credit": "Chris B",
    "isCombo": false
  },
  {
    "value": "One Away",
    "label": "One Away",
    "otherNames": [
      "Almost"
    ],
    "source": "o",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "One Cent",
    "label": "One Cent",
    "otherNames": [
      "One Cents"
    ],
    "source": "o",
    "credit": "Germaine Gates",
    "isCombo": false
  },
  {
    "value": "One Easy One Hard",
    "label": "One Easy One Hard",
    "otherNames": [],
    "source": "o",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "One Line",
    "label": "One Line",
    "otherNames": [],
    "source": "o",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "One Line And A Block Of Four",
    "label": "One Line And A Block Of Four",
    "otherNames": [],
    "source": "o",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "One Line No Free",
    "label": "One Line No Free",
    "otherNames": [],
    "source": "o",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "One Line Or Four Corners",
    "label": "One Line Or Four Corners",
    "otherNames": [],
    "source": "o",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "One Line Or Small X",
    "label": "One Line Or Small X",
    "otherNames": [],
    "source": "o",
    "credit": "Trevor",
    "isCombo": false
  },
  {
    "value": "One-Of-Each (All 3 Types Of Lines)",
    "label": "One-Of-Each (All 3 Types Of Lines)",
    "otherNames": [],
    "source": "o",
    "credit": "Marianne",
    "isCombo": false
  },
  {
    "value": "One Sided",
    "label": "One Sided",
    "otherNames": [],
    "source": "o",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Open Home Plate",
    "label": "Open Home Plate",
    "otherNames": [],
    "source": "o",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Outside Box Inside",
    "label": "Outside Box Inside",
    "otherNames": [],
    "source": "o",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Overtime",
    "label": "Overtime",
    "otherNames": [],
    "source": "o",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Owl",
    "label": "Owl",
    "otherNames": [],
    "source": "o",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Pacifier",
    "label": "Pacifier",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Pacman",
    "label": "Pacman",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Palm Tree",
    "label": "Palm Tree",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Park Bench",
    "label": "Park Bench",
    "otherNames": [],
    "source": "p",
    "credit": "Christina Ruth",
    "isCombo": false
  },
  {
    "value": "Peace",
    "label": "Peace",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Percent Sign",
    "label": "Percent Sign",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Percentage",
    "label": "Percentage",
    "otherNames": [],
    "source": "p",
    "credit": "Erica S",
    "isCombo": false
  },
  {
    "value": "Pi",
    "label": "Pi",
    "otherNames": [],
    "source": "p",
    "credit": "Mike Carter",
    "isCombo": false
  },
  {
    "value": "Piano",
    "label": "Piano",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Pickup Truck",
    "label": "Pickup Truck",
    "otherNames": [],
    "source": "p",
    "credit": "Jeffrey Sargent",
    "isCombo": false
  },
  {
    "value": "Picnic Table",
    "label": "Picnic Table",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Picnic Table Small",
    "label": "Picnic Table Small",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Pillar",
    "label": "Pillar",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Pinwheel",
    "label": "Pinwheel",
    "otherNames": [],
    "source": "p",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Pipe",
    "label": "Pipe",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Pitchfork",
    "label": "Pitchfork",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Pizza Pie",
    "label": "Pizza Pie",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "PL",
    "label": "PL",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Planet",
    "label": "Planet",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Plus",
    "label": "Plus",
    "otherNames": [],
    "source": "p",
    "credit": "Mulle",
    "isCombo": false
  },
  {
    "value": "Plus Or X",
    "label": "Plus Or X",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Plus Sign",
    "label": "Plus Sign",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Poodle",
    "label": "Poodle",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Pool Table",
    "label": "Pool Table",
    "otherNames": [],
    "source": "p",
    "credit": "Jordon",
    "isCombo": false
  },
  {
    "value": "Pool Table (Alternative)",
    "label": "Pool Table (Alternative)",
    "otherNames": [],
    "source": "p",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Popeye",
    "label": "Popeye",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Popsicle",
    "label": "Popsicle",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Postage Plus One Line",
    "label": "Postage Plus One Line",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Postage Stamp",
    "label": "Postage Stamp",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Postage Stamps",
    "label": "Postage Stamps",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Power T",
    "label": "Power T",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Present",
    "label": "Present",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Present With Bow",
    "label": "Present With Bow",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Pretzel",
    "label": "Pretzel",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Princess Dress",
    "label": "Princess Dress",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Propeller",
    "label": "Propeller",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Pumpkin",
    "label": "Pumpkin",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Pumpkin (Alternate)",
    "label": "Pumpkin (Alternate)",
    "otherNames": [],
    "source": "p",
    "credit": "Joetta",
    "isCombo": false
  },
  {
    "value": "Puppy",
    "label": "Puppy",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Purse",
    "label": "Purse",
    "otherNames": [],
    "source": "p",
    "credit": "Lindsey J",
    "isCombo": false
  },
  {
    "value": "Pyramid",
    "label": "Pyramid",
    "otherNames": [],
    "source": "p",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Q",
    "label": "Q",
    "otherNames": [],
    "source": "q",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Rabbit Ear TV",
    "label": "Rabbit Ear TV",
    "otherNames": [],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Race Car",
    "label": "Race Car",
    "otherNames": [],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Race Track",
    "label": "Race Track",
    "otherNames": [],
    "source": "r",
    "credit": "CJO",
    "isCombo": false
  },
  {
    "value": "Railroad Tracks",
    "label": "Railroad Tracks",
    "otherNames": [],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Railroad Tracks Horizontal",
    "label": "Railroad Tracks Horizontal",
    "otherNames": [],
    "source": "r",
    "credit": "Cheryl",
    "isCombo": false
  },
  {
    "value": "Rain",
    "label": "Rain",
    "otherNames": [],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Rainbow",
    "label": "Rainbow",
    "otherNames": [],
    "source": "r",
    "credit": "Patricia Morrison",
    "isCombo": false
  },
  {
    "value": "Razzle Dazzle (Any 3 Numbers In Each Row)",
    "label": "Razzle Dazzle (Any 3 Numbers In Each Row)",
    "otherNames": [],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Rectangle",
    "label": "Rectangle",
    "otherNames": [],
    "source": "r",
    "credit": "Robin Tatam",
    "isCombo": false
  },
  {
    "value": "Ref Whistle",
    "label": "Ref Whistle",
    "otherNames": [],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Reflex Angle",
    "label": "Reflex Angle",
    "otherNames": [],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Regular Bingo & Four Corners",
    "label": "Regular Bingo & Four Corners",
    "otherNames": [],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Regular Bingo",
    "label": "Regular Bingo",
    "otherNames": [
      "One Line",
      "1 Line",
      "Single Line",
      "Any Five In A Line"
    ],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Regular Bingo (Including 4 Corners + Postage Stamp)",
    "label": "Regular Bingo (Including 4 Corners + Postage Stamp)",
    "otherNames": [],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Regular Multi",
    "label": "Regular Multi",
    "otherNames": [],
    "source": "r",
    "credit": "Denny McKenzie",
    "isCombo": false
  },
  {
    "value": "Regular or 4 Corners",
    "label": "Regular or 4 Corners",
    "otherNames": [
      "Regular or Four Corners"
    ],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Regular, 4 Corners, Or Diagnonal",
    "label": "Regular, 4 Corners, Or Diagnonal",
    "otherNames": [],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Reindeer",
    "label": "Reindeer",
    "otherNames": [],
    "source": "r",
    "credit": "Paige T & Mac",
    "isCombo": false
  },
  {
    "value": "Ribbon",
    "label": "Ribbon",
    "otherNames": [],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Right",
    "label": "Right",
    "otherNames": [],
    "source": "r",
    "credit": "Convivial Kendrea",
    "isCombo": false
  },
  {
    "value": "Right Arrow",
    "label": "Right Arrow",
    "otherNames": [],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Right Corner Triangle",
    "label": "Right Corner Triangle",
    "otherNames": [
      "Right Side Triangle"
    ],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Right Turn",
    "label": "Right Turn",
    "otherNames": [],
    "source": "r",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "River",
    "label": "River",
    "otherNames": [],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Robs Pattern",
    "label": "Robs Pattern",
    "otherNames": [],
    "source": "r",
    "credit": "Robert Eberly",
    "isCombo": false
  },
  {
    "value": "Rocket",
    "label": "Rocket",
    "otherNames": [],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Rocketship",
    "label": "Rocketship",
    "otherNames": [],
    "source": "r",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Roller Coaster",
    "label": "Roller Coaster",
    "otherNames": [],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Roller Skate",
    "label": "Roller Skate",
    "otherNames": [],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Roman Numeral II",
    "label": "Roman Numeral II",
    "otherNames": [],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Rudolph",
    "label": "Rudolph",
    "otherNames": [
      "Rouldolph"
    ],
    "source": "r",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Sailboat",
    "label": "Sailboat",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Sailboat (Alternate)",
    "label": "Sailboat (Alternate)",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Sandbox",
    "label": "Sandbox",
    "otherNames": [],
    "source": "s",
    "credit": "Christina Ruth",
    "isCombo": false
  },
  {
    "value": "Sandwich",
    "label": "Sandwich",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Sand Shovel",
    "label": "Sand Shovel",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Santa Hat",
    "label": "Santa Hat",
    "otherNames": [],
    "source": "s",
    "credit": "Flo",
    "isCombo": false
  },
  {
    "value": "Santa's Boot",
    "label": "Santa's Boot",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Satellite",
    "label": "Satellite",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Satellite (Alternate)",
    "label": "Satellite (Alternate)",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Satellite (Alternate 2)",
    "label": "Satellite (Alternate 2)",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Sausage Links And Eggs",
    "label": "Sausage Links And Eggs",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Scale",
    "label": "Scale",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Scarecrow",
    "label": "Scarecrow",
    "otherNames": [
      "Bonhomme"
    ],
    "source": "s",
    "credit": "Micghelle Langer",
    "isCombo": false
  },
  {
    "value": "School Bus",
    "label": "School Bus",
    "otherNames": [],
    "source": "s",
    "credit": "Tupper Maggie",
    "isCombo": false
  },
  {
    "value": "Scramble—Any 2 Numbers Under Each Letter",
    "label": "Scramble—Any 2 Numbers Under Each Letter",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Seat Down!",
    "label": "Seat Down!",
    "otherNames": [],
    "source": "s",
    "credit": "Bob Versheck",
    "isCombo": false
  },
  {
    "value": "Seesaw",
    "label": "Seesaw",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Seventeen",
    "label": "Seventeen",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Shield",
    "label": "Shield",
    "otherNames": [],
    "source": "s",
    "credit": "Rosa Lara",
    "isCombo": false
  },
  {
    "value": "Shining Cross",
    "label": "Shining Cross",
    "otherNames": [],
    "source": "s",
    "credit": "Nico",
    "isCombo": false
  },
  {
    "value": "Shoe",
    "label": "Shoe",
    "otherNames": [
      "Stillettos",
      "High Heel"
    ],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Shopping Cart",
    "label": "Shopping Cart",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Shopping Cart (Alternate)",
    "label": "Shopping Cart (Alternate)",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Shot Glass",
    "label": "Shot Glass",
    "otherNames": [],
    "source": "s",
    "credit": "Tori",
    "isCombo": false
  },
  {
    "value": "Shotgun",
    "label": "Shotgun",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Side By Side",
    "label": "Side By Side",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Side By Side 2",
    "label": "Side By Side 2",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Side By Side Anywhere",
    "label": "Side By Side Anywhere",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Sides",
    "label": "Sides",
    "otherNames": [],
    "source": "s",
    "credit": "Dhemie",
    "isCombo": false
  },
  {
    "value": "Sideways Letter T",
    "label": "Sideways Letter T",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Sideways Letter U",
    "label": "Sideways Letter U",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Six Around The Corner",
    "label": "Six Around The Corner",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Skeleton",
    "label": "Skeleton",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Skeleton (Alternate)",
    "label": "Skeleton (Alternate)",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Ski Hat",
    "label": "Ski Hat",
    "otherNames": [],
    "source": "s",
    "credit": "Christina Ruth",
    "isCombo": false
  },
  {
    "value": "Skis",
    "label": "Skis",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Skis (Alternate)",
    "label": "Skis (Alternate)",
    "otherNames": [],
    "source": "s",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Skis Two Directions",
    "label": "Skis Two Directions",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Skull",
    "label": "Skull",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Slide",
    "label": "Slide",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Slingshot",
    "label": "Slingshot",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Sling Shot",
    "label": "Sling Shot",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Small Box With Vertical Line",
    "label": "Small Box With Vertical Line",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Small Crazy Y",
    "label": "Small Crazy Y",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Small Chair",
    "label": "Small Chair",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Small Flag",
    "label": "Small Flag",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Small Frame",
    "label": "Small Frame",
    "otherNames": [
      "Inside Border",
      "Inside Frame",
      "Around The Free",
      "Small Box"
    ],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Small Letter C",
    "label": "Small Letter C",
    "otherNames": [],
    "source": "s",
    "credit": "Joe Pfanzelter",
    "isCombo": false
  },
  {
    "value": "Small Letter L",
    "label": "Small Letter L",
    "otherNames": [],
    "source": "s",
    "credit": "Joe Pfanzelter",
    "isCombo": false
  },
  {
    "value": "Small Letter U",
    "label": "Small Letter U",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Small Letter X",
    "label": "Small Letter X",
    "otherNames": [
      "Small X"
    ],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Small Line",
    "label": "Small Line",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Small To Large Frame",
    "label": "Small To Large Frame",
    "otherNames": [],
    "source": "s",
    "credit": "MDSX",
    "isCombo": false
  },
  {
    "value": "Small Square (Anywhere)",
    "label": "Small Square (Anywhere)",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Small Square (As Shown)",
    "label": "Small Square (As Shown)",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Small V",
    "label": "Small V",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Small V (Alternate)",
    "label": "Small V (Alternate)",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Small X In A Corner",
    "label": "Small X In A Corner",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Smile",
    "label": "Smile",
    "otherNames": [
      "Happy Face"
    ],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Smile (Alternate)",
    "label": "Smile (Alternate)",
    "otherNames": [],
    "source": "s",
    "credit": "Lindsey J",
    "isCombo": false
  },
  {
    "value": "Smile (Alternate 2)",
    "label": "Smile (Alternate 2)",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Smiley Face",
    "label": "Smiley Face",
    "otherNames": [],
    "source": "s",
    "credit": "Allison D",
    "isCombo": false
  },
  {
    "value": "Snake",
    "label": "Snake",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Snowflake",
    "label": "Snowflake",
    "otherNames": [],
    "source": "s",
    "credit": "Jenny P",
    "isCombo": false
  },
  {
    "value": "Snowflake (Alternate)",
    "label": "Snowflake (Alternate)",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Snowflake (Alternate 2)",
    "label": "Snowflake (Alternate 2)",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Snow Mobile",
    "label": "Snow Mobile",
    "otherNames": [],
    "source": "s",
    "credit": "Christina Ruth",
    "isCombo": false
  },
  {
    "value": "Sombrero",
    "label": "Sombrero",
    "otherNames": [],
    "source": "s",
    "credit": "Mimi",
    "isCombo": false
  },
  {
    "value": "Spaceship",
    "label": "Spaceship",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Spider",
    "label": "Spider",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Spider (Alternate)",
    "label": "Spider (Alternate)",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Spider Web",
    "label": "Spider Web",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Spike Buck",
    "label": "Spike Buck",
    "otherNames": [],
    "source": "s",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Spin The Top",
    "label": "Spin The Top",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Spiral",
    "label": "Spiral",
    "otherNames": [],
    "source": "s",
    "credit": "Bob Versheck",
    "isCombo": false
  },
  {
    "value": "Spray Perfume",
    "label": "Spray Perfume",
    "otherNames": [],
    "source": "s",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Spring Basket",
    "label": "Spring Basket",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Sputnik",
    "label": "Sputnik",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Square To The Free",
    "label": "Square To The Free",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "St Pat",
    "label": "St Pat",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Stair",
    "label": "Stair",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Staircase",
    "label": "Staircase",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Stamp And 1 Line",
    "label": "Stamp And 1 Line",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Stamp and 4 Corners",
    "label": "Stamp and 4 Corners",
    "otherNames": [
      "Stamp and Four Corners"
    ],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Stamp (Corner) and Line",
    "label": "Stamp (Corner) and Line",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Standard Start",
    "label": "Standard Start",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Star",
    "label": "Star",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Star (Alternate)",
    "label": "Star (Alternate)",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Starburst",
    "label": "Starburst",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Station House 81",
    "label": "Station House 81",
    "otherNames": [],
    "source": "s",
    "credit": "Colton Poling",
    "isCombo": false
  },
  {
    "value": "Steering Wheel",
    "label": "Steering Wheel",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Straight",
    "label": "Straight",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Straight Angle",
    "label": "Straight Angle",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Straight Diagonal And Vertical",
    "label": "Straight Diagonal And Vertical",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Straight, Vertical & Diagonal",
    "label": "Straight, Vertical & Diagonal",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Straight Line",
    "label": "Straight Line",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Straight Line Or 4 Corners",
    "label": "Straight Line Or 4 Corners",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Straights",
    "label": "Straights",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Striiiiike",
    "label": "Striiiiike",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Stroller",
    "label": "Stroller",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Sun",
    "label": "Sun",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Sunglasses",
    "label": "Sunglasses",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Sunrise Sunset",
    "label": "Sunrise Sunset",
    "otherNames": [],
    "source": "s",
    "credit": "Tamara B",
    "isCombo": false
  },
  {
    "value": "SuperHuman",
    "label": "SuperHuman",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Support Our Troops",
    "label": "Support Our Troops",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Swatter and Fly",
    "label": "Swatter and Fly",
    "otherNames": [
      "Fly Swatter"
    ],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Swing",
    "label": "Swing",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Sword",
    "label": "Sword",
    "otherNames": [],
    "source": "s",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "T",
    "label": "T",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "T, X Or L",
    "label": "T, X Or L",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "T Bird",
    "label": "T Bird",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "T-Shirt",
    "label": "T-Shirt",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "T + Or X",
    "label": "T + Or X",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Teeter Totter",
    "label": "Teeter Totter",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Teeter Totter (Alternate)",
    "label": "Teeter Totter (Alternate)",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Teeter Totter (Either Direction)",
    "label": "Teeter Totter (Either Direction)",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Ten Lucky",
    "label": "Ten Lucky",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Tent",
    "label": "Tent",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Tent (Alternate)",
    "label": "Tent (Alternate)",
    "otherNames": [],
    "source": "t",
    "credit": "Sangeeta",
    "isCombo": false
  },
  {
    "value": "Terno",
    "label": "Terno",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Texas",
    "label": "Texas",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Texas T",
    "label": "Texas T",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "The 31 Game",
    "label": "The 31 Game",
    "otherNames": [],
    "source": "t",
    "credit": "IVETTE DANZO",
    "isCombo": false
  },
  {
    "value": "The Big 5-0!",
    "label": "The Big 5-0!",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "The Cross",
    "label": "The Cross",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "The Weird Way",
    "label": "The Weird Way",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Through Free Space",
    "label": "Through Free Space",
    "otherNames": [],
    "source": "t",
    "credit": "Chris Tyson",
    "isCombo": false
  },
  {
    "value": "TikTok Bingo",
    "label": "TikTok Bingo",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Tilted Stripes",
    "label": "Tilted Stripes",
    "otherNames": [],
    "source": "t",
    "credit": "Richard Ortiz",
    "isCombo": false
  },
  {
    "value": "Tipas Classic Bingo",
    "label": "Tipas Classic Bingo",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Tipi",
    "label": "Tipi",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "To The Right",
    "label": "To The Right",
    "otherNames": [],
    "source": "t",
    "credit": "Jordon",
    "isCombo": false
  },
  {
    "value": "Tombstone",
    "label": "Tombstone",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Too Dad",
    "label": "Too Dad",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Top",
    "label": "Top",
    "otherNames": [],
    "source": "t",
    "credit": "Marianne Nissen",
    "isCombo": false
  },
  {
    "value": "Top and Bottom",
    "label": "Top and Bottom",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Top Half",
    "label": "Top Half",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Top Hat",
    "label": "Top Hat",
    "otherNames": [],
    "source": "t",
    "credit": "Bob Versheck",
    "isCombo": false
  },
  {
    "value": "Top Hat (Alternate)",
    "label": "Top Hat (Alternate)",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Top Hat (Alternate 2)",
    "label": "Top Hat (Alternate 2)",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Top Or Bottom Pyramid",
    "label": "Top Or Bottom Pyramid",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Top Or Bottom Row",
    "label": "Top Or Bottom Row",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Top Row",
    "label": "Top Row",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Top or Bottom B-N-O",
    "label": "Top or Bottom B-N-O",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Torch",
    "label": "Torch",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Torch (Alternate)",
    "label": "Torch (Alternate)",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Tornado",
    "label": "Tornado",
    "otherNames": [],
    "source": "t",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Train",
    "label": "Train",
    "otherNames": [],
    "source": "t",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Train (Alternate)",
    "label": "Train (Alternate)",
    "otherNames": [],
    "source": "t",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Train Tracks (any two horizontal lines together)",
    "label": "Train Tracks (any two horizontal lines together)",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Tree",
    "label": "Tree",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Tree (Alternate)",
    "label": "Tree (Alternate)",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Triangle",
    "label": "Triangle",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Triangle (Alternate)",
    "label": "Triangle (Alternate)",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Triangle (Alternate 2)",
    "label": "Triangle (Alternate 2)",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Triangle & Horizontal",
    "label": "Triangle & Horizontal",
    "otherNames": [],
    "source": "t",
    "credit": "Marianne Nissen",
    "isCombo": false
  },
  {
    "value": "Triangle Game",
    "label": "Triangle Game",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Trio",
    "label": "Trio",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Triple Bingo",
    "label": "Triple Bingo",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Triple Bingo Anywhere",
    "label": "Triple Bingo Anywhere",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Triple Dot",
    "label": "Triple Dot",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Triple Dot (Alternate)",
    "label": "Triple Dot (Alternate)",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Triple Trio",
    "label": "Triple Trio",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Trophy",
    "label": "Trophy",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Tulip",
    "label": "Tulip",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Turkey",
    "label": "Turkey",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Turtle",
    "label": "Turtle",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Turtle (Alternate)",
    "label": "Turtle (Alternate)",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Turtle (Alternate 2)",
    "label": "Turtle (Alternate 2)",
    "otherNames": [],
    "source": "t",
    "credit": "Michelle Langer",
    "isCombo": false
  },
  {
    "value": "Turtle (Alternate 3)",
    "label": "Turtle (Alternate 3)",
    "otherNames": [],
    "source": "t",
    "credit": "Kevin F",
    "isCombo": false
  },
  {
    "value": "Two/Dikit",
    "label": "Two/Dikit",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Two Brackets",
    "label": "Two Brackets",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Two Layer Cake",
    "label": "Two Layer Cake",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Two Left Feet",
    "label": "Two Left Feet",
    "otherNames": [],
    "source": "t",
    "credit": "Bob Versheck",
    "isCombo": false
  },
  {
    "value": "Two Lines",
    "label": "Two Lines",
    "otherNames": [
      "2 Lines"
    ],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Two Line Bingo (All The Ways)",
    "label": "Two Line Bingo (All The Ways)",
    "otherNames": [],
    "source": "t",
    "credit": "JJJ",
    "isCombo": false
  },
  {
    "value": "Two Lines No Free Space",
    "label": "Two Lines No Free Space",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Two Only",
    "label": "Two Only",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Two Rows",
    "label": "Two Rows",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Two Stamps Anywhere",
    "label": "Two Stamps Anywhere",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Two Stamps Anywhere (Alternate)",
    "label": "Two Stamps Anywhere (Alternate)",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Two Stamps Anywhere (Alternate 2)",
    "label": "Two Stamps Anywhere (Alternate 2)",
    "otherNames": [],
    "source": "t",
    "credit": "Lynda Hughes",
    "isCombo": false
  },
  {
    "value": "Two Stamps On 1 Card",
    "label": "Two Stamps On 1 Card",
    "otherNames": [],
    "source": "t",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "U Shape",
    "label": "U Shape",
    "otherNames": [],
    "source": "u",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Ultimate Spider Web",
    "label": "Ultimate Spider Web",
    "otherNames": [
      "Spider Web"
    ],
    "source": "u",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Umbrella",
    "label": "Umbrella",
    "otherNames": [],
    "source": "u",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Unity",
    "label": "Unity",
    "otherNames": [],
    "source": "u",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Up",
    "label": "Up",
    "otherNames": [],
    "source": "u",
    "credit": "Convivial Kendrea",
    "isCombo": false
  },
  {
    "value": "Up Arrow",
    "label": "Up Arrow",
    "otherNames": [
      "North Arrow"
    ],
    "source": "u",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Upper Right Triangle",
    "label": "Upper Right Triangle",
    "otherNames": [],
    "source": "u",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Upside Down Bell",
    "label": "Upside Down Bell",
    "otherNames": [],
    "source": "u",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Upside Down T",
    "label": "Upside Down T",
    "otherNames": [],
    "source": "u",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Upside Down U",
    "label": "Upside Down U",
    "otherNames": [],
    "source": "u",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "UWM",
    "label": "UWM",
    "otherNames": [],
    "source": "u",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "V",
    "label": "V",
    "otherNames": [],
    "source": "v",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "V (Alternate)",
    "label": "V (Alternate)",
    "otherNames": [],
    "source": "v",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "V Pattern",
    "label": "V Pattern",
    "otherNames": [],
    "source": "v",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Vertical",
    "label": "Vertical",
    "otherNames": [],
    "source": "v",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Valentine",
    "label": "Valentine",
    "otherNames": [],
    "source": "v",
    "credit": "Rosa Lara",
    "isCombo": false
  },
  {
    "value": "Warm Up",
    "label": "Warm Up",
    "otherNames": [],
    "source": "w",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Warm Up (Alternate)",
    "label": "Warm Up (Alternate)",
    "otherNames": [],
    "source": "w",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Waterfall",
    "label": "Waterfall",
    "otherNames": [],
    "source": "w",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Water Pipe",
    "label": "Water Pipe",
    "otherNames": [],
    "source": "w",
    "credit": "Sticky's Social Lounge",
    "isCombo": false
  },
  {
    "value": "Wave",
    "label": "Wave",
    "otherNames": [],
    "source": "w",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Wave (Alternate)",
    "label": "Wave (Alternate)",
    "otherNames": [],
    "source": "w",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Wedding Dress",
    "label": "Wedding Dress",
    "otherNames": [],
    "source": "w",
    "credit": "Susan A",
    "isCombo": false
  },
  {
    "value": "Wheel",
    "label": "Wheel",
    "otherNames": [],
    "source": "w",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Where Is The Free?",
    "label": "Where Is The Free?",
    "otherNames": [],
    "source": "w",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Why",
    "label": "Why",
    "otherNames": [],
    "source": "w",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Wine Glass",
    "label": "Wine Glass",
    "otherNames": [],
    "source": "w",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Wine Glass (Alternate)",
    "label": "Wine Glass (Alternate)",
    "otherNames": [],
    "source": "w",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Winners Choice (4 Corners Count, 2 Clusters Cannot Interlock)",
    "label": "Winners Choice (4 Corners Count, 2 Clusters Cannot Interlock)",
    "otherNames": [],
    "source": "w",
    "credit": "Michelle Hahn",
    "isCombo": false
  },
  {
    "value": "Witch Hat",
    "label": "Witch Hat",
    "otherNames": [
      "Witches Hat"
    ],
    "source": "w",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Worm",
    "label": "Worm",
    "otherNames": [],
    "source": "w",
    "credit": "VFW Post 3596",
    "isCombo": false
  },
  {
    "value": "Wreath",
    "label": "Wreath",
    "otherNames": [],
    "source": "w",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Xoxo",
    "label": "Xoxo",
    "otherNames": [],
    "source": "x",
    "credit": "Alexis Montefalcon",
    "isCombo": false
  },
  {
    "value": "X O",
    "label": "X O",
    "otherNames": [],
    "source": "x",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Z and Ns are Free",
    "label": "Z and Ns are Free",
    "otherNames": [],
    "source": "z",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Zero",
    "label": "Zero",
    "otherNames": [],
    "source": "z",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "Zig Zag Either Way",
    "label": "Zig Zag Either Way",
    "otherNames": [],
    "source": "z",
    "credit": null,
    "isCombo": false
  },
  {
    "value": "ZLE",
    "label": "ZLE",
    "otherNames": [],
    "source": "z",
    "credit": null,
    "isCombo": false
  }
];

/**
 * Get pattern metadata by value
 * @param {string} value - Pattern value to find
 * @returns {Object|null} Pattern metadata or null if not found
 */
export function getPatternMetadataByValue(value) {
  return patternMetadata.find(p => p.value === value) || null;
}

/**
 * Get all pattern metadata sorted alphabetically
 * @returns {Array} Sorted pattern metadata
 */
export function getPatternMetadataAlphabetically() {
  return [...patternMetadata].sort((a, b) => a.label.localeCompare(b.label));
}

/**
 * Search pattern metadata by term
 * @param {string} searchTerm - Search term
 * @returns {Array} Matching patterns
 */
export function searchPatternMetadata(searchTerm) {
  const term = searchTerm.toLowerCase();
  return patternMetadata.filter(p => {
    const searchableText = [
      p.value,
      p.label,
      ...p.otherNames,
      p.credit || ''
    ].join(' ').toLowerCase();

    return searchableText.includes(term);
  });
}
